// //работающий код со статистикой открытий писем
// import React, { useState, useEffect } from "react";
// import { getSmtpAccounts } from "../api/api";
// import { getDatabasesWithCount } from "../api/databasesApi";
// import { useLoading } from "./useLoading";
// import axios from "axios";

// export default function Campaigns() {
//   const [smtpAccounts, setSmtpAccounts] = useState([]);
//   const [selectedSmtpIds, setSelectedSmtpIds] = useState([]);
//   const [databases, setDatabases] = useState([]);
//   const [campaigns, setCampaigns] = useState([]);
//   const [selectedCampaignId, setSelectedCampaignId] = useState(null);
//   const [campaignDetails, setCampaignDetails] = useState(null);
//   const [progress, setProgress] = useState(0);
//   const [sentEmails, setSentEmails] = useState([]);
//   const [emailFilter, setEmailFilter] = useState("all");
//   const [selectedDbId, setSelectedDbId] = useState(null);
//   const [copiedText, setCopiedText] = useState(null);
//   const [nextSendTimer, setNextSendTimer] = useState(null);
//   const [timeLeft, setTimeLeft] = useState(null);

//   const [campaignName, setCampaignName] = useState("");
//   const [campaignSubject, setCampaignSubject] = useState("");
//   const [campaignTexts, setCampaignTexts] = useState([]);

//   const [campaignStats, setCampaignStats] = useState(null);
//   const [opensList, setOpensList] = useState([]);

//   const [sequenceName, setSequenceName] = useState("");
//   const [sequence, setSequence] = useState([
//     { subject: "", text: "", delayMinutes: 0, delaySeconds: 0 },
//     { subject: "", text: "", delayMinutes: 0, delaySeconds: 5 },
//     { subject: "", text: "", delayMinutes: 0, delaySeconds: 5 },
//   ]);

//   const { loading, withLoading } = useLoading();
//   const [selectAllSmtp, setSelectAllSmtp] = useState(false);

//   const campaignTextRef = React.useRef(null);
//   const sequenceRefs = React.useRef([]);

//   const updateSequence = (index, field, value) => {
//     const updated = [...sequence];
//     updated[index][field] = value;
//     setSequence(updated);
//   };

//   const copyToClipboard = (text) => {
//     if (!text) return;
//     if (navigator.clipboard && navigator.clipboard.writeText) {
//       navigator.clipboard.writeText(text)
//         .then(() => {
//           setCopiedText(text.slice(0, 50) + (text.length > 50 ? '...' : ''));
//           setTimeout(() => setCopiedText(null), 2000);
//         })
//         .catch(() => fallbackCopy(text));
//     } else {
//       fallbackCopy(text);
//     }
//   };

//   const fallbackCopy = (text) => {
//     const textarea = document.createElement('textarea');
//     textarea.value = text;
//     textarea.style.position = 'fixed';
//     textarea.style.opacity = '0';
//     document.body.appendChild(textarea);
//     textarea.select();
//     try {
//       document.execCommand('copy');
//       setCopiedText(text.slice(0, 50) + (text.length > 50 ? '...' : ''));
//       setTimeout(() => setCopiedText(null), 2000);
//     } catch (err) {
//       console.error('Ошибка копирования:', err);
//     }
//     document.body.removeChild(textarea);
//   };

//   const insertVariable = (variable) => {
//     const active = document.activeElement;

//     if (active && active.tagName === "TEXTAREA") {
//       const start = active.selectionStart ?? active.value.length;
//       const end = active.selectionEnd ?? active.value.length;
//       const newValue = active.value.slice(0, start) + variable + active.value.slice(end);

//       if (active === campaignTextRef.current) {
//         setCampaignTexts(newValue.split("|"));
//       } else {
//         const idx = sequenceRefs.current.indexOf(active);
//         if (idx !== -1) updateSequence(idx, "text", newValue);
//       }

//       requestAnimationFrame(() => {
//         active.focus();
//         const pos = start + variable.length;
//         active.setSelectionRange(pos, pos);
//       });
//       return;
//     }

//     const textarea = campaignTextRef.current;
//     if (textarea) {
//       const current = textarea.value;
//       const newValue = current + variable;
//       setCampaignTexts(newValue.split("|"));
//       requestAnimationFrame(() => {
//         textarea.focus();
//         textarea.setSelectionRange(newValue.length, newValue.length);
//       });
//     } else {
//       setCampaignTexts((prev) => {
//         const last = prev[prev.length - 1] || "";
//         return [...prev.slice(0, -1), last + variable];
//       });
//     }
//   };

//   const calculateNextSendTime = (sentEmailsList, campaign) => {
//     if (!campaign || !sentEmailsList.length) return null;
//     const lastSent = sentEmailsList
//       .filter(e => e.status === 'sent')
//       .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
//     if (!lastSent) return null;
//     const sentCount = sentEmailsList.filter(e => e.status === 'sent').length;
//     const defaultDelays = [0, 5, 10];
//     const delayIndex = Math.min(sentCount, defaultDelays.length - 1);
//     const delayMinutes = defaultDelays[delayIndex] || 5;
//     const nextSendTime = new Date(lastSent.created_at);
//     nextSendTime.setMinutes(nextSendTime.getMinutes() + delayMinutes);
//     return nextSendTime;
//   };

//   useEffect(() => {
//     async function load() {
//       try {
//         const smtpRes = await withLoading(() => getSmtpAccounts());
//         setSmtpAccounts(smtpRes.data);
//         const dbRes = await withLoading(() => getDatabasesWithCount());
//         setDatabases(dbRes.data);
//         const campaignsRes = await withLoading(() => axios.get("/api/campaigns"));
//         setCampaigns(campaignsRes.data);
//       } catch (err) {
//         console.error(err);
//       }
//     }
//     load();
//   }, []);

//   // Загрузка статистики при выборе кампании
//   useEffect(() => {
//     if (!selectedCampaignId) {
//       setCampaignStats(null);
//       setOpensList([]);
//       return;
//     }
//     (async () => {
//       try {
//         const [statsRes, opensRes] = await Promise.all([
//           axios.get(`/api/campaigns/${selectedCampaignId}/stats`),
//           axios.get(`/api/campaigns/${selectedCampaignId}/opens`),
//         ]);
//         setCampaignStats(statsRes.data);
//         setOpensList(opensRes.data);
//       } catch (err) {
//         console.error("Ошибка загрузки статистики:", err);
//       }
//     })();
//   }, [selectedCampaignId, sentEmails.length]);

//   useEffect(() => {
//     if (!selectedCampaignId) return;
//     const interval = setInterval(async () => {
//       try {
//         const res = await axios.get(`/api/campaigns/${selectedCampaignId}`);
//         const data = res.data;
//         setCampaignDetails(data);
//         setProgress(Math.round(((data.sent_count + data.failed_count) / data.total_count) * 100));
//         const emailsRes = await axios.get(`/api/campaigns/${selectedCampaignId}/emails`);
//         setSentEmails(emailsRes.data);
//         const nextTime = calculateNextSendTime(emailsRes.data, data);
//         setNextSendTimer(nextTime);
//         setCampaigns((prev) =>
//           prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: data.status } : c)
//         );
//         if (data.status === "completed" || data.status === "stopped") clearInterval(interval);
//       } catch (err) {
//         console.error(err);
//       }
//     }, 2000);
//     return () => clearInterval(interval);
//   }, [selectedCampaignId]);

//   useEffect(() => {
//     if (!nextSendTimer) { setTimeLeft(null); return; }
//     const updateTimer = () => {
//       const now = new Date();
//       const diff = Math.max(0, Math.floor((nextSendTimer - now) / 1000));
//       if (diff <= 0) setTimeLeft(null);
//       else setTimeLeft(`${Math.floor(diff / 60)}:${(diff % 60).toString().padStart(2, '0')}`);
//     };
//     updateTimer();
//     const timerInterval = setInterval(updateTimer, 1000);
//     return () => clearInterval(timerInterval);
//   }, [nextSendTimer]);

//   const toggleSmtpSelect = (id) => {
//     setSelectedSmtpIds((prev) =>
//       prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
//     );
//   };

//   const toggleSelectAllSmtp = () => {
//     if (selectAllSmtp) setSelectedSmtpIds([]);
//     else setSelectedSmtpIds(smtpAccounts.map((s) => s.id));
//     setSelectAllSmtp(!selectAllSmtp);
//   };

//   const handleCreateCampaign = async () => {
//     if (!selectedDbId || !campaignName || !campaignSubject || !campaignTexts.length || !selectedSmtpIds.length) {
//       alert("Заполните все поля: выберите почты для работы, базу и напишите письмо");
//       return;
//     }
//     try {
//       const res = await withLoading(() =>
//         axios.post("/api/campaigns", {
//           databaseId: Number(selectedDbId),
//           name: campaignName,
//           subject: campaignSubject,
//           texts: campaignTexts,
//           smtpIds: selectedSmtpIds,
//         })
//       );
//       const newCampaign = res.data;
//       setCampaigns([newCampaign, ...campaigns]);
//       setSelectedCampaignId(newCampaign.campaignId);
//     } catch (err) {
//       console.error(err.response?.data || err);
//       alert(`Ошибка: ${err.response?.data?.error || err.message}`);
//     }
//   };

//   const handleCreateSequenceCampaign = async () => {
//     if (!selectedDbId || !sequenceName.trim() || selectedSmtpIds.length === 0) {
//       alert("Заполните базу, название и SMTP");
//       return;
//     }
//     if (!sequence.every((s) => s.subject.trim() && s.text.trim())) {
//       alert("Заполните subject и text для всех писем");
//       return;
//     }
//     const defaultSubject = sequence[0]?.subject || "No Subject";
//     try {
//       const res = await withLoading(() =>
//         axios.post("/api/campaigns/sequence", {
//           databaseId: Number(selectedDbId),
//           name: sequenceName,
//           smtpIds: selectedSmtpIds,
//           sequence,
//           subject: defaultSubject,
//         })
//       );
//       const newCampaign = res.data;
//       const delays = sequence.slice(1).map(s =>
//         s.delayMinutes > 0 ? `${s.delayMinutes}м` : `${s.delaySeconds}с`
//       );
//       const sequenceInfo = ` (${sequence.length} письма, паузы: ${delays.join(', ')})`;
//       setCampaigns((prev) => [
//         { campaignId: newCampaign.campaignId, name: sequenceName + sequenceInfo, status: "running", isSequence: true, sequenceInfo },
//         ...prev,
//       ]);
//       setSelectedCampaignId(newCampaign.campaignId);
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.error || "Ошибка запуска sequence");
//     }
//   };

//   const handlePause = async () => {
//     if (!selectedCampaignId) return;
//     try {
//       await withLoading(() => axios.post(`/api/campaigns/${selectedCampaignId}/pause`));
//       setCampaignDetails((prev) => ({ ...prev, status: "paused" }));
//       setCampaigns((prev) => prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: "paused" } : c));
//     } catch (err) {
//       alert(err.response?.data?.error || "Ошибка при постановке на паузу");
//     }
//   };

//   const handleResume = async () => {
//     if (!selectedCampaignId) return;
//     try {
//       await withLoading(() => axios.post(`/api/campaigns/${selectedCampaignId}/resume`));
//       setCampaignDetails((prev) => ({ ...prev, status: "running" }));
//       setCampaigns((prev) => prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: "running" } : c));
//     } catch (err) {
//       alert(err.response?.data?.error || "Ошибка при возобновлении");
//     }
//   };

//   const handleStop = async () => {
//     if (!selectedCampaignId) return;
//     try {
//       await withLoading(() => axios.post(`/api/campaigns/${selectedCampaignId}/stop`));
//       setCampaignDetails((prev) => ({ ...prev, status: "stopped" }));
//       setCampaigns((prev) => prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: "stopped" } : c));
//     } catch (err) {
//       alert(err.response?.data?.error || "Ошибка при остановке");
//     }
//   };

//   const displayedEmails = sentEmails.filter((e) => {
//     if (emailFilter === "all") return true;
//     if (emailFilter === "sent") return e.status === "sent";
//     if (emailFilter === "failed") return e.status === "failed";
//     return true;
//   });

//   const statusLabel = (status) => {
//     if (status === "paused") return "⏸️ На паузе";
//     if (status === "running") return "▶️ Выполняется";
//     if (status === "completed") return "✅ Завершена";
//     if (status === "stopped") return "⏹️ Остановлена";
//     return status;
//   };

//   const findTracking = (email) => opensList.find(o => o.recipient_email === email);

//   return (
//     <div className="min-h-screen bg-gray-50 p-3 md:p-4">
//       {loading && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="w-20 h-20 border-8 border-gray-200 border-t-8 border-t-blue-600 rounded-full animate-spin" />
//         </div>
//       )}

//       {copiedText && (
//         <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-4 py-2 rounded-xl shadow-lg z-50 text-sm">
//           📋 Скопировано
//         </div>
//       )}

//       <h1 className="text-xl md:text-2xl font-bold mb-4">Email кампании</h1>

//       <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">

//         {/* ===== ЛЕВАЯ ПАНЕЛЬ ===== */}
//         <div className="w-full md:w-1/2 flex flex-col space-y-4">

//           {/* SMTP */}
//           <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//             <h2 className="text-base md:text-lg font-semibold mb-2">Выберите почты для рассылок</h2>

//             {/* Desktop: table */}
//             <div className="hidden md:block overflow-auto border rounded-xl">
//               <table className="w-full text-sm">
//                 <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider">
//                   <tr>
//                     <th className="px-2 py-1 text-left">
//                       <input type="checkbox" checked={selectAllSmtp} onChange={toggleSelectAllSmtp} />
//                     </th>
//                     <th className="px-2 py-1 text-left">Email</th>
//                     <th className="px-2 py-1 text-left">Сегодня</th>
//                     <th className="px-2 py-1 text-left">Всего</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {smtpAccounts.map((s) => (
//                     <tr key={s.id} className="border-t hover:bg-gray-50 transition">
//                       <td className="px-2 py-1">
//                         <input
//                           type="checkbox"
//                           checked={selectedSmtpIds.includes(s.id)}
//                           onChange={() => toggleSmtpSelect(s.id)}
//                         />
//                       </td>
//                       <td className="px-2 py-1 font-medium text-gray-800">{s.email}</td>
//                       <td className="px-2 py-1 text-gray-600">{s.sentToday || 0}</td>
//                       <td className="px-2 py-1 text-gray-600">{s.sentTotal || 0}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Mobile: cards */}
//             <div className="md:hidden space-y-2">
//               {smtpAccounts.length > 0 && (
//                 <div className="flex items-center gap-2 px-2 py-1.5 bg-gray-50 rounded-lg">
//                   <input
//                     type="checkbox"
//                     checked={selectAllSmtp}
//                     onChange={toggleSelectAllSmtp}
//                     className="w-4 h-4"
//                   />
//                   <span className="text-xs text-gray-600">Выбрать все</span>
//                 </div>
//               )}
//               {smtpAccounts.length === 0 && (
//                 <div className="text-xs text-gray-400 text-center py-4">Нет SMTP</div>
//               )}
//               {smtpAccounts.map((s) => (
//                 <label
//                   key={s.id}
//                   className={`flex items-start gap-2 p-2 rounded-lg cursor-pointer transition ${
//                     selectedSmtpIds.includes(s.id) ? 'bg-blue-50 ring-1 ring-blue-400' : 'bg-gray-50'
//                   }`}
//                 >
//                   <input
//                     type="checkbox"
//                     checked={selectedSmtpIds.includes(s.id)}
//                     onChange={() => toggleSmtpSelect(s.id)}
//                     className="mt-0.5 w-4 h-4 flex-shrink-0"
//                   />
//                   <div className="flex-1 min-w-0">
//                     <div className="text-xs font-medium text-gray-800 truncate">{s.email}</div>
//                     <div className="flex gap-3 mt-0.5 text-[11px] text-gray-500">
//                       <span>Сегодня: {s.sentToday || 0}</span>
//                       <span>Всего: {s.sentTotal || 0}</span>
//                     </div>
//                   </div>
//                 </label>
//               ))}
//             </div>
//           </div>

//           {/* CAMPAIGNS LIST */}
//           <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//             <h2 className="text-base md:text-lg font-semibold mb-2">Все кампании</h2>
//             <div className="flex flex-col space-y-1 max-h-60 md:max-h-40 overflow-y-auto">
//               {campaigns.length === 0 && (
//                 <div className="text-xs text-gray-400 text-center py-4">Нет кампаний</div>
//               )}
//               {campaigns.map((c) => (
//                 <button
//                   key={c.campaignId}
//                   onClick={() => setSelectedCampaignId(c.campaignId)}
//                   className={`text-left px-2 py-2 rounded-xl transition ${
//                     c.campaignId === selectedCampaignId
//                       ? "bg-blue-50 border-2 border-blue-500"
//                       : "hover:bg-gray-100 border-2 border-transparent"
//                   }`}
//                 >
//                   <div className="font-medium text-sm truncate">#{c.campaignId} — {c.name}</div>
//                   <div className="text-xs text-gray-500 flex items-center gap-2 flex-wrap mt-0.5">
//                     {statusLabel(c.status)}
//                     {c.status === "running" && (
//                       <div className="w-3 h-3 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
//                     )}
//                     {c.isSequence && c.status === "running" && timeLeft && (
//                       <span className="bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded-full text-[10px]">
//                         ⏳ {timeLeft}
//                       </span>
//                     )}
//                   </div>
//                 </button>
//               ))}
//             </div>
//           </div>

//           {/* CAMPAIGN DETAILS */}
//           {campaignDetails && (
//             <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 space-y-2">
//               <h2 className="text-base md:text-lg font-semibold mb-2">
//                 Детали #{selectedCampaignId}
//               </h2>

//               <div className="text-xs md:text-sm text-gray-600 flex items-center gap-2 flex-wrap">
//                 <span className="font-semibold">Статус:</span>
//                 <span className="capitalize">{statusLabel(campaignDetails.status)}</span>
//                 {campaignDetails.status === "running" && (
//                   <div className="w-3 h-3 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
//                 )}
//               </div>

//               <div className="w-full bg-gray-200 h-2 rounded-full mb-2 overflow-hidden">
//                 <div
//                   className={`h-2 transition-all duration-500 ${
//                     campaignDetails.status === "paused" ? "bg-yellow-500" :
//                     campaignDetails.status === "completed" ? "bg-blue-500" :
//                     campaignDetails.status === "stopped" ? "bg-red-500" :
//                     "bg-green-600"
//                   }`}
//                   style={{ width: `${progress}%` }}
//                 />
//               </div>

//               <div className="text-xs md:text-sm text-gray-600">
//                 {campaignDetails.sent_count} отправлено / {campaignDetails.failed_count} ошибок / {campaignDetails.total_count} всего
//               </div>

//               {/* ===== КАРТОЧКИ: ОТКРЫТО / КЛИКОВ / ОТВЕТИЛИ / ЛИДОВ ===== */}
//               {campaignStats && campaignStats.sent > 0 && (
//                 <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-3">
//                   <div className="bg-blue-50 border border-blue-200 rounded-xl p-2.5">
//                     <div className="text-[10px] md:text-xs text-blue-700 font-medium">📬 Открыто</div>
//                     <div className="text-lg md:text-xl font-bold text-blue-800">
//                       {campaignStats.opened}
//                       <span className="text-xs font-normal text-blue-600 ml-1">
//                         ({campaignStats.openRate}%)
//                       </span>
//                     </div>
//                     <div className="text-[10px] text-blue-500 mt-0.5">
//                       всего открытий: {campaignStats.totalOpens}
//                     </div>
//                   </div>

//                   <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-2.5">
//                     <div className="text-[10px] md:text-xs text-emerald-700 font-medium">🖱️ Кликов</div>
//                     <div className="text-lg md:text-xl font-bold text-emerald-800">
//                       {campaignStats.clicked}
//                       <span className="text-xs font-normal text-emerald-600 ml-1">
//                         ({campaignStats.clickRate}%)
//                       </span>
//                     </div>
//                     <div className="text-[10px] text-emerald-500 mt-0.5">
//                       всего кликов: {campaignStats.totalClicks}
//                     </div>
//                   </div>

//                   <div className="bg-teal-50 border border-teal-200 rounded-xl p-2.5">
//                     <div className="text-[10px] md:text-xs text-teal-700 font-medium">💬 Ответили</div>
//                     <div className="text-lg md:text-xl font-bold text-teal-800">
//                       {campaignStats.replied}
//                       <span className="text-xs font-normal text-teal-600 ml-1">
//                         ({campaignStats.replyRate}%)
//                       </span>
//                     </div>
//                     <div className="text-[10px] text-teal-500 mt-0.5">уникальных</div>
//                   </div>

//                   <div className="bg-purple-50 border border-purple-200 rounded-xl p-2.5">
//                     <div className="text-[10px] md:text-xs text-purple-700 font-medium">🎯 Лидов</div>
//                     <div className="text-lg md:text-xl font-bold text-purple-800">
//                       {campaignStats.leads}
//                       <span className="text-xs font-normal text-purple-600 ml-1">
//                         ({campaignStats.leadRate}%)
//                       </span>
//                     </div>
//                     <div className="text-[10px] text-purple-500 mt-0.5">из ответивших</div>
//                   </div>
//                 </div>
//               )}

//               {/* ===== ВОРОНКА КОНВЕРСИИ ===== */}
//               {campaignStats && campaignStats.sent > 0 && (
//                 <div className="bg-gradient-to-br from-blue-50 to-purple-50 border border-blue-200 rounded-xl p-3 md:p-4 mt-3">
//                   <div className="text-sm font-semibold text-gray-800 mb-3 flex items-center gap-2">
//                     🎯 Воронка кампании
//                   </div>

//                   <div className="space-y-2.5">
//                     {/* Отправлено */}
//                     <div>
//                       <div className="flex justify-between text-xs md:text-sm mb-1">
//                         <span className="text-gray-600 font-medium">📨 Отправлено</span>
//                         <span className="font-bold text-gray-800">
//                           {campaignStats.sent}
//                           <span className="text-gray-400 font-normal ml-1">100%</span>
//                         </span>
//                       </div>
//                       <div className="w-full bg-white rounded-full h-2 overflow-hidden">
//                         <div className="h-full bg-gray-400" style={{ width: "100%" }} />
//                       </div>
//                     </div>

//                     {/* Открыто */}
//                     <div>
//                       <div className="flex justify-between text-xs md:text-sm mb-1">
//                         <span className="text-gray-600 font-medium">📬 Открыто</span>
//                         <span className="font-bold text-cyan-700">
//                           {campaignStats.opened}
//                           <span className="text-gray-400 font-normal ml-1">
//                             {campaignStats.openFromSent}%
//                           </span>
//                         </span>
//                       </div>
//                       <div className="w-full bg-white rounded-full h-2 overflow-hidden">
//                         <div
//                           className="h-full bg-cyan-500 transition-all duration-500"
//                           style={{ width: `${campaignStats.openFromSent}%` }}
//                         />
//                       </div>
//                     </div>

//                     {/* Ответили */}
//                     <div>
//                       <div className="flex justify-between text-xs md:text-sm mb-1">
//                         <span className="text-gray-600 font-medium">💬 Ответили</span>
//                         <span className="font-bold text-teal-700">
//                           {campaignStats.replied}
//                           <span className="text-gray-400 font-normal ml-1">
//                             {campaignStats.replyFromOpened}% от открытых
//                           </span>
//                         </span>
//                       </div>
//                       <div className="w-full bg-white rounded-full h-2 overflow-hidden">
//                         <div
//                           className="h-full bg-teal-500 transition-all duration-500"
//                           style={{ width: `${campaignStats.replyFromOpened}%` }}
//                         />
//                       </div>
//                     </div>

//                     {/* Лиды */}
//                     <div>
//                       <div className="flex justify-between text-xs md:text-sm mb-1">
//                         <span className="text-gray-600 font-medium">🎯 Стали лидами</span>
//                         <span className="font-bold text-purple-700">
//                           {campaignStats.leads}
//                           <span className="text-gray-400 font-normal ml-1">
//                             {campaignStats.leadFromReplied}% от ответивших
//                           </span>
//                         </span>
//                       </div>
//                       <div className="w-full bg-white rounded-full h-2 overflow-hidden">
//                         <div
//                           className="h-full bg-purple-500 transition-all duration-500"
//                           style={{ width: `${campaignStats.leadFromReplied}%` }}
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   {/* Итоговая конверсия */}
//                   <div className="mt-3 pt-3 border-t border-blue-200 flex items-center justify-between">
//                     <span className="text-xs text-gray-500">Итоговая конверсия в лида</span>
//                     <span className="text-2xl font-bold text-purple-700">
//                       {campaignStats.leadRate}%
//                     </span>
//                   </div>
//                 </div>
//               )}

//               <div className="flex flex-wrap gap-2 mt-2">
//                 {campaignDetails.status === "running" && (
//                   <>
//                     <button
//                       onClick={handlePause}
//                       className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-yellow-500 text-white hover:bg-yellow-600 transition text-sm"
//                     >
//                       ⏸️ Пауза
//                     </button>
//                     <button
//                       onClick={handleStop}
//                       className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-red-500 text-white hover:bg-red-600 transition text-sm"
//                     >
//                       ⏹️ Остановить
//                     </button>
//                   </>
//                 )}
//                 {campaignDetails.status === "paused" && (
//                   <>
//                     <button
//                       onClick={handleResume}
//                       className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-green-500 text-white hover:bg-green-600 transition text-sm"
//                     >
//                       ▶️ Возобновить
//                     </button>
//                     <button
//                       onClick={handleStop}
//                       className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-red-500 text-white hover:bg-red-600 transition text-sm"
//                     >
//                       ⏹️ Остановить
//                     </button>
//                   </>
//                 )}
//                 {(campaignDetails.status === "stopped" || campaignDetails.status === "completed") && (
//                   <span className="text-xs md:text-sm text-gray-500">
//                     {campaignDetails.status === "completed" ? "✅ Завершена" : "⏹️ Остановлена"}
//                   </span>
//                 )}
//               </div>

//               {/* Desktop: emails table */}
//               <div className="hidden md:block overflow-x-auto rounded-xl border border-gray-200 max-h-60 overflow-y-auto mt-2">
//                 <table className="w-full text-sm">
//                   <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider sticky top-0 z-10">
//                     <tr>
//                       <th className="px-2 py-1 text-left">ПОЛУЧАТЕЛЬ</th>
//                       <th className="px-2 py-1 text-left">СТАТУС</th>
//                       <th className="px-2 py-1 text-left">SMTP ПОЧТА</th>
//                       <th className="px-2 py-1 text-left">ОТПРАВЛЕНО</th>
//                       <th className="px-2 py-1 text-left">ОТКРЫТО</th>
//                       <th className="px-2 py-1 text-left">ТЕМА</th>
//                       <th className="px-2 py-1 text-left">ТЕКСТ</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {displayedEmails.map((e) => {
//                       const t = findTracking(e.recipient_email);
//                       return (
//                         <tr key={e.id} className="border-t hover:bg-gray-50 transition">
//                           <td className="px-2 py-1">{e.recipient_email}</td>
//                           <td className="px-2 py-1 capitalize">{e.status}</td>
//                           <td className="px-2 py-1">{e.smtp_email}</td>
//                           <td className="px-2 py-1">{new Date(e.created_at).toLocaleString()}</td>
//                           <td className="px-2 py-1">
//                             {!t ? (
//                               <span className="text-gray-300">—</span>
//                             ) : t.opened_at ? (
//                               <span className="inline-flex items-center gap-1 text-emerald-600 text-xs">
//                                 ✅ {t.open_count}
//                                 {t.clicked_at && (
//                                   <span className="text-blue-600">· 🖱️{t.click_count}</span>
//                                 )}
//                               </span>
//                             ) : (
//                               <span className="text-gray-400 text-xs">⏳</span>
//                             )}
//                           </td>
//                           <td
//                             className="px-2 py-1 min-w-[200px] max-w-[300px] break-words cursor-pointer hover:text-blue-600 transition"
//                             onClick={() => copyToClipboard(e.subject || campaignSubject)}
//                             title="Кликни чтобы скопировать тему"
//                           >
//                             {e.subject || campaignSubject}
//                           </td>
//                           <td
//                             className="px-2 py-1 min-w-[200px] max-w-[300px] break-words cursor-pointer hover:text-blue-600 transition"
//                             onClick={() => {
//                               const text = Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ");
//                               copyToClipboard(text);
//                             }}
//                             title="Кликни чтобы скопировать текст"
//                           >
//                             {Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ")}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Mobile: emails cards */}
//               <div className="md:hidden space-y-2 mt-2 max-h-80 overflow-y-auto">
//                 {displayedEmails.length === 0 && (
//                   <div className="text-xs text-gray-400 text-center py-4">Нет писем</div>
//                 )}
//                 {displayedEmails.map((e) => {
//                   const t = findTracking(e.recipient_email);
//                   return (
//                     <div key={e.id} className="bg-gray-50 rounded-xl p-2 text-xs">
//                       <div className="flex justify-between items-start gap-2 mb-1">
//                         <div className="font-medium text-gray-800 truncate flex-1">{e.recipient_email}</div>
//                         <span className={`px-1.5 py-0.5 rounded-full text-[10px] whitespace-nowrap ${
//                           e.status === "sent" ? "bg-green-100 text-green-700" :
//                           e.status === "failed" ? "bg-red-100 text-red-700" :
//                           "bg-gray-100 text-gray-700"
//                         }`}>
//                           {e.status}
//                         </span>
//                       </div>
//                       <div className="text-gray-500 mb-1 truncate">SMTP: {e.smtp_email}</div>
//                       <div className="text-gray-400 mb-1.5">{new Date(e.created_at).toLocaleString('ru-RU')}</div>

//                       {t && (
//                         <div className="flex gap-2 text-[11px] mb-1.5">
//                           {t.opened_at ? (
//                             <span className="text-emerald-600">✅ Открыто {t.open_count}×</span>
//                           ) : (
//                             <span className="text-gray-400">⏳ Не открыто</span>
//                           )}
//                           {t.clicked_at && (
//                             <span className="text-blue-600">🖱️ {t.click_count}×</span>
//                           )}
//                         </div>
//                       )}

//                       <div
//                         className="text-blue-600 cursor-pointer truncate mb-0.5"
//                         onClick={() => copyToClipboard(e.subject || campaignSubject)}
//                       >
//                         📧 {e.subject || campaignSubject}
//                       </div>
//                       <div
//                         className="text-gray-600 cursor-pointer line-clamp-2"
//                         onClick={() => {
//                           const text = Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ");
//                           copyToClipboard(text);
//                         }}
//                       >
//                         📄 {Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ")}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* ===== ПРАВАЯ ПАНЕЛЬ ===== */}
//         <div className="w-full md:w-2/3 flex flex-col space-y-4">

//           {/* DATABASE SELECT */}
//           <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//             <h2 className="text-base md:text-lg font-semibold mb-2">База контактов</h2>
//             <select
//               value={selectedDbId || ""}
//               onChange={(e) => setSelectedDbId(e.target.value)}
//               className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
//             >
//               <option value="">Выберите базу</option>
//               {databases.map((db) => (
//                 <option key={db.id} value={db.id}>
//                   {db.name} ({db.contacts_count})
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* NORMAL CAMPAIGN */}
//           <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 space-y-3">
//             <h2 className="text-base md:text-lg font-semibold mb-1">Разовая классическая рассылка</h2>

//             <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 text-xs">
//               <div className="font-medium text-blue-900 mb-2">
//                 Используйте переменные для персонализации (клик — вставить в текст):
//               </div>
//               <div className="flex flex-wrap gap-1.5 mb-2">
//                 {['{{companyName}}', '{{name}}', '{{email}}', '{{city}}'].map((v) => (
//                   <code
//                     key={v}
//                     onClick={() => insertVariable(v)}
//                     title="Кликните, чтобы вставить в активное поле"
//                     className="bg-white px-2 py-0.5 rounded border border-blue-200 text-blue-800 font-mono text-[11px] cursor-pointer hover:bg-blue-100 hover:border-blue-400 active:scale-95 transition select-none"
//                   >
//                     {v}
//                   </code>
//                 ))}
//               </div>
//               <div className="text-blue-700 text-[11px] leading-relaxed">
//                 <b>Рандомизация:</b> разделяйте варианты через{' '}
//                 <code className="bg-white px-1 rounded border border-blue-200 font-mono">|</code>
//                 {' '}— будет выбран случайный
//               </div>
//             </div>

//             <input
//               placeholder="Название кампании: - Рассылка по юристам 24.09"
//               value={campaignName}
//               onChange={(e) => setCampaignName(e.target.value)}
//               className="w-full border rounded-xl px-3 py-2 text-sm"
//             />
//             <input
//               placeholder="Тема письма: - По поводу разработки ПО для {{name}}"
//               value={campaignSubject}
//               onChange={(e) => setCampaignSubject(e.target.value)}
//               className="w-full border rounded-xl px-3 py-2 text-sm"
//             />

//             <textarea
//               ref={campaignTextRef}
//               placeholder="Текст письма: Добрый день, {{name}} | Здравствуйте, {{name}}, ваша компания называется {{companyName}}?"
//               value={campaignTexts.join("|")}
//               onChange={(e) => setCampaignTexts(e.target.value.split("|"))}
//               className="w-full border rounded-xl px-3 py-2 text-sm"
//               rows={5}
//             />

//             <button
//               onClick={handleCreateCampaign}
//               className="w-full md:w-auto px-4 py-2 rounded-xl bg-green-600 text-white hover:bg-green-700 transition shadow-md text-sm"
//             >
//               Запустить рассылку
//             </button>
//           </div>

//           {/* SEQUENCE CAMPAIGN */}
//           <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 space-y-2">
//             <h2 className="text-base md:text-lg font-semibold mb-1">Цепочка из 3-х писем (для профессионалов)</h2>
//             <input
//               placeholder="Название кампании"
//               value={sequenceName}
//               onChange={(e) => setSequenceName(e.target.value)}
//               className="w-full border rounded-xl px-3 py-2 text-sm"
//             />
//             {sequence.map((step, i) => (
//               <div key={i} className="mb-3">
//                 {i !== 0 && (
//                   <div className="flex gap-2 items-center flex-wrap text-xs bg-yellow-50 border border-yellow-200 rounded-lg px-2 py-1.5 mb-1.5">
//                     <span className="font-medium text-yellow-800">⏳ Пауза перед письмом {i + 1}:</span>
//                     <input
//                       type="number"
//                       placeholder="Мин"
//                       value={step.delayMinutes || 0}
//                       onChange={(e) => updateSequence(i, "delayMinutes", Number(e.target.value))}
//                       className="border rounded-lg px-2 py-1 w-16 text-sm"
//                     />
//                     <span>мин</span>
//                     <input
//                       type="number"
//                       placeholder="Сек"
//                       value={step.delaySeconds || 0}
//                       onChange={(e) => updateSequence(i, "delaySeconds", Number(e.target.value))}
//                       className="border rounded-lg px-2 py-1 w-16 text-sm"
//                     />
//                     <span>сек</span>
//                     <span className="text-[10px] text-yellow-700 ml-auto">1 день = 1440 мин</span>
//                   </div>
//                 )}

//                 <div className="border rounded-xl p-2">
//                   <div className="font-semibold mb-1 text-sm">Письмо {i + 1}</div>
//                   <input
//                     placeholder="Тема письма"
//                     value={step.subject}
//                     onChange={(e) => updateSequence(i, "subject", e.target.value)}
//                     className="w-full border rounded-xl px-2 py-1 mb-1 text-sm"
//                   />
//                   <textarea
//                     ref={(el) => (sequenceRefs.current[i] = el)}
//                     placeholder="Текст"
//                     value={step.text}
//                     onChange={(e) => updateSequence(i, "text", e.target.value)}
//                     className="w-full border rounded-xl px-2 py-1 mb-1 text-sm"
//                     rows={3}
//                   />
//                 </div>
//               </div>
//             ))}
//             <button
//               onClick={handleCreateSequenceCampaign}
//               className="w-full md:w-auto px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition shadow-md text-sm"
//             >
//               Запустить цепочку
//             </button>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         @keyframes fade-in {
//           from { opacity: 0; transform: translate(-50%, -20px); }
//           to { opacity: 1; transform: translate(-50%, 0); }
//         }
//         .animate-fade-in { animation: fade-in 0.3s ease-out; }
//       `}</style>
//     </div>
//   );
// }






// import React, { useState, useEffect } from "react";
// import { getSmtpAccounts } from "../api/api";
// import { getDatabasesWithCount } from "../api/databasesApi";
// import { useLoading } from "./useLoading";
// import axios from "axios";

// import {
//   Mail, MailOpen, MessageSquare, Target, MousePointerClick,
//   Send, Play, Pause, Square, CheckCircle2, Clock,
//   ChevronRight, Copy, FileText,
// } from "lucide-react";

// export default function Campaigns() {
//   const [smtpAccounts, setSmtpAccounts] = useState([]);
//   const [selectedSmtpIds, setSelectedSmtpIds] = useState([]);
//   const [databases, setDatabases] = useState([]);
//   const [campaigns, setCampaigns] = useState([]);
//   const [selectedCampaignId, setSelectedCampaignId] = useState(null);
//   const [campaignDetails, setCampaignDetails] = useState(null);
//   const [progress, setProgress] = useState(0);
//   const [sentEmails, setSentEmails] = useState([]);
//   const [emailFilter, setEmailFilter] = useState("all");
//   const [selectedDbId, setSelectedDbId] = useState(null);
//   const [excludeDbIds, setExcludeDbIds] = useState([]);
//   const [excludeAlreadySent, setExcludeAlreadySent] = useState(false);
//   const [excludeReplied, setExcludeReplied] = useState(false);
//   const [copiedText, setCopiedText] = useState(null);
//   const [nextSendTimer, setNextSendTimer] = useState(null);
//   const [timeLeft, setTimeLeft] = useState(null);
// const [templates, setTemplates] = useState([]);
// const [showTemplatesModal, setShowTemplatesModal] = useState(false);
//   const [campaignName, setCampaignName] = useState("");
//   const [campaignSubject, setCampaignSubject] = useState("");
//   const [campaignTexts, setCampaignTexts] = useState([]);

//   const [campaignStats, setCampaignStats] = useState(null);
//   const [opensList, setOpensList] = useState([]);

//   const [sequenceName, setSequenceName] = useState("");
//   const [sequence, setSequence] = useState([
//     { subject: "", text: "", delayMinutes: 0, delaySeconds: 0 },
//     { subject: "", text: "", delayMinutes: 0, delaySeconds: 5 },
//     { subject: "", text: "", delayMinutes: 0, delaySeconds: 5 },
//   ]);

//   const { loading, withLoading } = useLoading();
//   const [selectAllSmtp, setSelectAllSmtp] = useState(false);

//   const campaignTextRef = React.useRef(null);
//   const sequenceRefs = React.useRef([]);

//   const updateSequence = (index, field, value) => {
//     const updated = [...sequence];
//     updated[index][field] = value;
//     setSequence(updated);
//   };

//   const copyToClipboard = (text) => {
//     if (!text) return;
//     if (navigator.clipboard && navigator.clipboard.writeText) {
//       navigator.clipboard.writeText(text)
//         .then(() => {
//           setCopiedText(text.slice(0, 50) + (text.length > 50 ? '...' : ''));
//           setTimeout(() => setCopiedText(null), 2000);
//         })
//         .catch(() => fallbackCopy(text));
//     } else {
//       fallbackCopy(text);
//     }
//   };

//   const fallbackCopy = (text) => {
//     const textarea = document.createElement('textarea');
//     textarea.value = text;
//     textarea.style.position = 'fixed';
//     textarea.style.opacity = '0';
//     document.body.appendChild(textarea);
//     textarea.select();
//     try {
//       document.execCommand('copy');
//       setCopiedText(text.slice(0, 50) + (text.length > 50 ? '...' : ''));
//       setTimeout(() => setCopiedText(null), 2000);
//     } catch (err) {
//       console.error('Ошибка копирования:', err);
//     }
//     document.body.removeChild(textarea);
//   };

//   const insertVariable = (variable) => {
//     const active = document.activeElement;

//     if (active && active.tagName === "TEXTAREA") {
//       const start = active.selectionStart ?? active.value.length;
//       const end = active.selectionEnd ?? active.value.length;
//       const newValue = active.value.slice(0, start) + variable + active.value.slice(end);

//       if (active === campaignTextRef.current) {
//         setCampaignTexts(newValue.split("|"));
//       } else {
//         const idx = sequenceRefs.current.indexOf(active);
//         if (idx !== -1) updateSequence(idx, "text", newValue);
//       }

//       requestAnimationFrame(() => {
//         active.focus();
//         const pos = start + variable.length;
//         active.setSelectionRange(pos, pos);
//       });
//       return;
//     }

//     const textarea = campaignTextRef.current;
//     if (textarea) {
//       const current = textarea.value;
//       const newValue = current + variable;
//       setCampaignTexts(newValue.split("|"));
//       requestAnimationFrame(() => {
//         textarea.focus();
//         textarea.setSelectionRange(newValue.length, newValue.length);
//       });
//     } else {
//       setCampaignTexts((prev) => {
//         const last = prev[prev.length - 1] || "";
//         return [...prev.slice(0, -1), last + variable];
//       });
//     }
//   };

//   const calculateNextSendTime = (sentEmailsList, campaign) => {
//     if (!campaign || !sentEmailsList.length) return null;
//     const lastSent = sentEmailsList
//       .filter(e => e.status === 'sent')
//       .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
//     if (!lastSent) return null;
//     const sentCount = sentEmailsList.filter(e => e.status === 'sent').length;
//     const defaultDelays = [0, 5, 10];
//     const delayIndex = Math.min(sentCount, defaultDelays.length - 1);
//     const delayMinutes = defaultDelays[delayIndex] || 5;
//     const nextSendTime = new Date(lastSent.created_at);
//     nextSendTime.setMinutes(nextSendTime.getMinutes() + delayMinutes);
//     return nextSendTime;
//   };

// useEffect(() => {
//   async function load() {
//     try {
//       const smtpRes = await withLoading(() => getSmtpAccounts());
//       setSmtpAccounts(smtpRes.data);
//       const dbRes = await withLoading(() => getDatabasesWithCount());
//       setDatabases(dbRes.data);
//       const campaignsRes = await withLoading(() => axios.get("/api/campaigns"));
//       setCampaigns(campaignsRes.data);

//       // ← НОВОЕ: шаблоны
//       const tplRes = await axios.get("/api/templates");
//       setTemplates(tplRes.data);
//     } catch (err) {
//       console.error(err);
//     }
//   }
//   load();
// }, []);

//   useEffect(() => {
//     if (!selectedCampaignId) {
//       setCampaignStats(null);
//       setOpensList([]);
//       return;
//     }
//     (async () => {
//       try {
//         const [statsRes, opensRes] = await Promise.all([
//           axios.get(`/api/campaigns/${selectedCampaignId}/stats`),
//           axios.get(`/api/campaigns/${selectedCampaignId}/opens`),
//         ]);
//         setCampaignStats(statsRes.data);
//         setOpensList(opensRes.data);
//       } catch (err) {
//         console.error("Ошибка загрузки статистики:", err);
//       }
//     })();
//   }, [selectedCampaignId, sentEmails.length]);

//   useEffect(() => {
//     if (!selectedCampaignId) return;
//     const interval = setInterval(async () => {
//       try {
//         const res = await axios.get(`/api/campaigns/${selectedCampaignId}`);
//         const data = res.data;
//         setCampaignDetails(data);
//         setProgress(Math.round(((data.sent_count + data.failed_count) / data.total_count) * 100));
//         const emailsRes = await axios.get(`/api/campaigns/${selectedCampaignId}/emails`);
//         setSentEmails(emailsRes.data);
//         const nextTime = calculateNextSendTime(emailsRes.data, data);
//         setNextSendTimer(nextTime);
//         setCampaigns((prev) =>
//           prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: data.status } : c)
//         );
//         if (data.status === "completed" || data.status === "stopped") clearInterval(interval);
//       } catch (err) {
//         console.error(err);
//       }
//     }, 2000);
//     return () => clearInterval(interval);
//   }, [selectedCampaignId]);

//   useEffect(() => {
//     if (!nextSendTimer) { setTimeLeft(null); return; }
//     const updateTimer = () => {
//       const now = new Date();
//       const diff = Math.max(0, Math.floor((nextSendTimer - now) / 1000));
//       if (diff <= 0) setTimeLeft(null);
//       else setTimeLeft(`${Math.floor(diff / 60)}:${(diff % 60).toString().padStart(2, '0')}`);
//     };
//     updateTimer();
//     const timerInterval = setInterval(updateTimer, 1000);
//     return () => clearInterval(timerInterval);
//   }, [nextSendTimer]);

//   const toggleSmtpSelect = (id) => {
//     setSelectedSmtpIds((prev) =>
//       prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
//     );
//   };

//   const toggleSelectAllSmtp = () => {
//     if (selectAllSmtp) setSelectedSmtpIds([]);
//     else setSelectedSmtpIds(smtpAccounts.map((s) => s.id));
//     setSelectAllSmtp(!selectAllSmtp);
//   };

//   const handleCreateCampaign = async () => {
//     if (!selectedDbId || !campaignName || !campaignSubject || !campaignTexts.length || !selectedSmtpIds.length) {
//       alert("Заполните все поля: выберите почты для работы, базу и напишите письмо");
//       return;
//     }
//     try {
//       const res = await withLoading(() =>
//         axios.post("/api/campaigns", {
//           databaseId: Number(selectedDbId),
//           name: campaignName,
//           subject: campaignSubject,
//           texts: campaignTexts,
//           smtpIds: selectedSmtpIds,
//           excludeDatabaseIds: excludeDbIds.map(Number),
//           excludeAlreadySent,
//           excludeReplied,
//         })
//       );
//       const newCampaign = res.data;
//       setCampaigns([newCampaign, ...campaigns]);
//       setSelectedCampaignId(newCampaign.campaignId);
//       setExcludeDbIds([]);
//       setExcludeAlreadySent(false);
//       setExcludeReplied(false);
//     } catch (err) {
//       console.error(err.response?.data || err);
//       alert(`Ошибка: ${err.response?.data?.error || err.message}`);
//     }
//   };

//   const applyTemplate = (tpl) => {
//   if (!tpl) return;
//   if (campaignSubject || campaignTexts.length > 0) {
//     if (!window.confirm("Заменить текущую тему и текст шаблоном?")) return;
//   }
//   setCampaignSubject(tpl.subject || "");
//   // если в шаблоне есть разделитель "|" — разбиваем на варианты
//   const bodyText = tpl.body || "";
//   setCampaignTexts(bodyText.includes("|") ? bodyText.split("|") : [bodyText]);
//   setShowTemplatesModal(false);
// };

//   const handleCreateSequenceCampaign = async () => {
//     if (!selectedDbId || !sequenceName.trim() || selectedSmtpIds.length === 0) {
//       alert("Заполните базу, название и SMTP");
//       return;
//     }
//     if (!sequence.every((s) => s.subject.trim() && s.text.trim())) {
//       alert("Заполните subject и text для всех писем");
//       return;
//     }
//     const defaultSubject = sequence[0]?.subject || "No Subject";
//     try {
//       const res = await withLoading(() =>
//         axios.post("/api/campaigns/sequence", {
//           databaseId: Number(selectedDbId),
//           name: sequenceName,
//           smtpIds: selectedSmtpIds,
//           sequence,
//           subject: defaultSubject,
//         })
//       );
//       const newCampaign = res.data;
//       const delays = sequence.slice(1).map(s =>
//         s.delayMinutes > 0 ? `${s.delayMinutes}м` : `${s.delaySeconds}с`
//       );
//       const sequenceInfo = ` (${sequence.length} письма, паузы: ${delays.join(', ')})`;
//       setCampaigns((prev) => [
//         { campaignId: newCampaign.campaignId, name: sequenceName + sequenceInfo, status: "running", isSequence: true, sequenceInfo },
//         ...prev,
//       ]);
//       setSelectedCampaignId(newCampaign.campaignId);
//       setExcludeDbIds([]);
//       setExcludeAlreadySent(false);
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.error || "Ошибка запуска sequence");
//     }
//   };

//   const handlePause = async () => {
//     if (!selectedCampaignId) return;
//     try {
//       await withLoading(() => axios.post(`/api/campaigns/${selectedCampaignId}/pause`));
//       setCampaignDetails((prev) => ({ ...prev, status: "paused" }));
//       setCampaigns((prev) => prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: "paused" } : c));
//     } catch (err) {
//       alert(err.response?.data?.error || "Ошибка при постановке на паузу");
//     }
//   };

//   const handleResume = async () => {
//     if (!selectedCampaignId) return;
//     try {
//       await withLoading(() => axios.post(`/api/campaigns/${selectedCampaignId}/resume`));
//       setCampaignDetails((prev) => ({ ...prev, status: "running" }));
//       setCampaigns((prev) => prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: "running" } : c));
//     } catch (err) {
//       alert(err.response?.data?.error || "Ошибка при возобновлении");
//     }
//   };

//   const handleStop = async () => {
//     if (!selectedCampaignId) return;
//     try {
//       await withLoading(() => axios.post(`/api/campaigns/${selectedCampaignId}/stop`));
//       setCampaignDetails((prev) => ({ ...prev, status: "stopped" }));
//       setCampaigns((prev) => prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: "stopped" } : c));
//     } catch (err) {
//       alert(err.response?.data?.error || "Ошибка при остановке");
//     }
//   };

//   const displayedEmails = sentEmails.filter((e) => {
//     if (emailFilter === "all") return true;
//     if (emailFilter === "sent") return e.status === "sent";
//     if (emailFilter === "failed") return e.status === "failed";
//     return true;
//   });

//   const StatusBadge = ({ status }) => {
//     if (status === "paused") return (
//       <span className="inline-flex items-center gap-1 text-yellow-600">
//         <Pause size={12} /> На паузе
//       </span>
//     );
//     if (status === "running") return (
//       <span className="inline-flex items-center gap-1 text-green-600">
//         <Play size={12} /> Выполняется
//       </span>
//     );
//     if (status === "completed") return (
//       <span className="inline-flex items-center gap-1 text-green-600">
//         <CheckCircle2 size={12} /> Завершена
//       </span>
//     );
//     if (status === "stopped") return (
//       <span className="inline-flex items-center gap-1 text-red-600">
//         <Square size={12} /> Остановлена
//       </span>
//     );
//     return <span className="text-gray-500">{status}</span>;
//   };

//   const findTracking = (email) => opensList.find(o => o.recipient_email === email);

//   return (
//     <div className="min-h-screen bg-gray-50 p-3 md:p-4">
//       {loading && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="w-20 h-20 border-8 border-gray-200 border-t-8 border-t-blue-600 rounded-full animate-spin" />
//         </div>
//       )}

//       {copiedText && (
//         <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-4 py-2 rounded-xl shadow-lg z-50 text-sm inline-flex items-center gap-2">
//           <CheckCircle2 size={14} /> Скопировано
//         </div>
//       )}

//       <h1 className="text-xl md:text-2xl font-bold mb-4 flex items-center gap-2">
//         <Send size={22} className="text-blue-600" /> Email кампании
//       </h1>

//       <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">

//         {/* ===== ЛЕВАЯ ПАНЕЛЬ ===== */}
//         <div className="w-full md:w-1/2 flex flex-col space-y-4">

//           {/* SMTP */}
//           <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//             <h2 className="text-base md:text-lg font-semibold mb-2 flex items-center gap-2">
//               Выберите почты для рассылок
//             </h2>

//             <div className="hidden md:block overflow-auto border rounded-xl">
//               <table className="w-full text-sm">
//                 <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider">
//                   <tr>
//                     <th className="px-2 py-1 text-left">
//                       <input type="checkbox" checked={selectAllSmtp} onChange={toggleSelectAllSmtp} />
//                     </th>
//                     <th className="px-2 py-1 text-left">Email</th>
//                     <th className="px-2 py-1 text-left">Сегодня</th>
//                     <th className="px-2 py-1 text-left">Всего</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {smtpAccounts.map((s) => (
//                     <tr key={s.id} className="border-t hover:bg-gray-50 transition">
//                       <td className="px-2 py-1">
//                         <input
//                           type="checkbox"
//                           checked={selectedSmtpIds.includes(s.id)}
//                           onChange={() => toggleSmtpSelect(s.id)}
//                         />
//                       </td>
//                       <td className="px-2 py-1 font-medium text-gray-800">{s.email}</td>
//                       <td className="px-2 py-1 text-gray-600">{s.sentToday || 0}</td>
//                       <td className="px-2 py-1 text-gray-600">{s.sentTotal || 0}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             <div className="md:hidden space-y-2">
//               {smtpAccounts.length > 0 && (
//                 <div className="flex items-center gap-2 px-2 py-1.5 bg-gray-50 rounded-lg">
//                   <input
//                     type="checkbox"
//                     checked={selectAllSmtp}
//                     onChange={toggleSelectAllSmtp}
//                     className="w-4 h-4"
//                   />
//                   <span className="text-xs text-gray-600">Выбрать все</span>
//                 </div>
//               )}
//               {smtpAccounts.length === 0 && (
//                 <div className="text-xs text-gray-400 text-center py-4">Нет SMTP</div>
//               )}
//               {smtpAccounts.map((s) => (
//                 <label
//                   key={s.id}
//                   className={`flex items-start gap-2 p-2 rounded-lg cursor-pointer transition ${
//                     selectedSmtpIds.includes(s.id) ? 'bg-blue-50 ring-1 ring-blue-400' : 'bg-gray-50'
//                   }`}
//                 >
//                   <input
//                     type="checkbox"
//                     checked={selectedSmtpIds.includes(s.id)}
//                     onChange={() => toggleSmtpSelect(s.id)}
//                     className="mt-0.5 w-4 h-4 flex-shrink-0"
//                   />
//                   <div className="flex-1 min-w-0">
//                     <div className="text-xs font-medium text-gray-800 truncate">{s.email}</div>
//                     <div className="flex gap-3 mt-0.5 text-[11px] text-gray-500">
//                       <span>Сегодня: {s.sentToday || 0}</span>
//                       <span>Всего: {s.sentTotal || 0}</span>
//                     </div>
//                   </div>
//                 </label>
//               ))}
//             </div>
//           </div>

//           {/* ===== CAMPAIGNS LIST ===== */}
//           <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//             <h2 className="text-base md:text-lg font-semibold mb-2 flex items-center gap-2">
//               Все кампании
//             </h2>
//             <div className="flex flex-col space-y-1.5 max-h-72 md:max-h-80 overflow-y-auto">
//               {campaigns.length === 0 && (
//                 <div className="text-xs text-gray-400 text-center py-4">Нет кампаний</div>
//               )}
//               {campaigns.map((c) => {
//                 const dateStr = c.created_at
//                   ? new Date(c.created_at).toLocaleString('ru-RU', {
//                       day: '2-digit',
//                       month: '2-digit',
//                       hour: '2-digit',
//                       minute: '2-digit',
//                     })
//                   : '—';

//                 const sent = c.sent ?? c.sent_count ?? 0;
//                 const opened = c.opened ?? 0;
//                 const replied = c.replied ?? 0;
//                 const leads = c.leads ?? 0;
//                 const total = c.total ?? c.total_count ?? 0;

//                 const isActive = c.campaignId === selectedCampaignId;

//                 return (
//                   <button
//                     key={c.campaignId}
//                     onClick={() => setSelectedCampaignId(c.campaignId)}
//                     className={`w-full text-left px-3 py-3 rounded-xl transition flex items-center gap-3 ${
//                       isActive
//                         ? "bg-blue-50 border-2 border-blue-500"
//                         : "hover:bg-gray-50 border-2 border-transparent"
//                     }`}
//                   >
//                     <div className="flex-1 min-w-0">
//                       {/* Строка 1 */}
//                       <div className="flex items-center gap-2 flex-wrap">
//                         <span className="font-semibold text-sm text-gray-800 truncate">
//                           #{c.campaignId} — {c.name}
//                         </span>
//                         <span className="text-xs flex-shrink-0">
//                           <StatusBadge status={c.status} />
//                         </span>
//                         {c.status === "running" && (
//                           <div className="w-3 h-3 border-2 border-blue-500 border-t-transparent rounded-full animate-spin flex-shrink-0" />
//                         )}
//                         {c.isSequence && c.status === "running" && timeLeft && (
//                           <span className="bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded-full text-[10px] flex-shrink-0 inline-flex items-center gap-1">
//                             <Clock size={10} /> {timeLeft}
//                           </span>
//                         )}
//                       </div>

//                       {/* Строка 2 */}
//                       <div className="text-xs text-gray-500 mt-1 flex items-center flex-wrap gap-x-2 gap-y-0.5">
//                         <span className="inline-flex items-center gap-1">
//                           <Send size={11} className="text-gray-400" />
//                           <b className="text-gray-400">{sent}</b>
//                           {total > 0 && (
//                             <span className="text-gray-400">
//                               из <b>{total}</b>
//                             </span>
//                           )}
//                         </span>
//                         <span className="text-gray-300">·</span>
//                         <span className="inline-flex items-center gap-1">
//                           <MailOpen size={11} className="text-gray-400" />
//                           <b className="text-gray-400">{opened} открыли</b>
//                         </span>
//                         <span className="text-gray-300">·</span>
//                         <span className="inline-flex items-center gap-1">
//                           <MessageSquare size={11} className="text-gray-400" />
//                           <b className="text-gray-400">{replied} ответили</b>
//                         </span>
//                         <span className="text-gray-300">·</span>
//                         <span className="inline-flex items-center gap-1">
//                           <Target size={11} className="text-purple-500" />
//                           <b className="text-purple-600">{leads} лидов</b>
//                         </span>
//                         <span className="text-gray-300">·</span>
//                         <span className="text-gray-400">{dateStr}</span>
//                       </div>
//                     </div>

//                     <ChevronRight
//                       size={18}
//                       className={`flex-shrink-0 transition ${
//                         isActive ? "text-blue-500" : "text-gray-300"
//                       }`}
//                     />
//                   </button>
//                 );
//               })}
//             </div>
//           </div>

//           {/* CAMPAIGN DETAILS */}
//           {campaignDetails && (
//             <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 space-y-2">
//               <h2 className="text-base md:text-lg font-semibold mb-2">
//                 Детали #{selectedCampaignId}
//               </h2>

//               <div className="text-xs md:text-sm text-gray-600 flex items-center gap-2 flex-wrap">
//                 <span className="font-semibold">Статус:</span>
//                 <span className="capitalize"><StatusBadge status={campaignDetails.status} /></span>
//                 {campaignDetails.status === "running" && (
//                   <div className="w-3 h-3 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
//                 )}
//               </div>

//               <div className="w-full bg-gray-200 h-2 rounded-full mb-2 overflow-hidden">
//                 <div
//                   className={`h-2 transition-all duration-500 ${
//                     campaignDetails.status === "paused" ? "bg-yellow-500" :
//                     campaignDetails.status === "completed" ? "bg-blue-500" :
//                     campaignDetails.status === "stopped" ? "bg-red-500" :
//                     "bg-green-600"
//                   }`}
//                   style={{ width: `${progress}%` }}
//                 />
//               </div>

//               <div className="text-xs md:text-sm text-gray-600">
//                 {campaignDetails.sent_count} отправлено / {campaignDetails.failed_count} ошибок / {campaignDetails.total_count} всего
//               </div>

//               {/* КАРТОЧКИ */}
//               {campaignStats && campaignStats.sent > 0 && (
//                 <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-3">
//                   <div className="bg-blue-50 border border-blue-200 rounded-xl p-2.5">
//                     <div className="text-[10px] md:text-xs text-blue-700 font-medium flex items-center gap-1">
//                       <MailOpen size={12} /> Открыто
//                     </div>
//                     <div className="text-lg md:text-xl font-bold text-blue-800">
//                       {campaignStats.opened}
//                       <span className="text-xs font-normal text-blue-600 ml-1">
//                         ({campaignStats.openRate}%)
//                       </span>
//                     </div>
//                     <div className="text-[10px] text-blue-500 mt-0.5">
//                       всего открытий: {campaignStats.totalOpens}
//                     </div>
//                   </div>

//                   <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-2.5">
//                     <div className="text-[10px] md:text-xs text-emerald-700 font-medium flex items-center gap-1">
//                       <MousePointerClick size={12} /> Кликов
//                     </div>
//                     <div className="text-lg md:text-xl font-bold text-emerald-800">
//                       {campaignStats.clicked}
//                       <span className="text-xs font-normal text-emerald-600 ml-1">
//                         ({campaignStats.clickRate}%)
//                       </span>
//                     </div>
//                     <div className="text-[10px] text-emerald-500 mt-0.5">
//                       всего кликов: {campaignStats.totalClicks}
//                     </div>
//                   </div>

//                   <div className="bg-teal-50 border border-teal-200 rounded-xl p-2.5">
//                     <div className="text-[10px] md:text-xs text-teal-700 font-medium flex items-center gap-1">
//                       <MessageSquare size={12} /> Ответили
//                     </div>
//                     <div className="text-lg md:text-xl font-bold text-teal-800">
//                       {campaignStats.replied}
//                       <span className="text-xs font-normal text-teal-600 ml-1">
//                         ({campaignStats.replyRate}%)
//                       </span>
//                     </div>
//                     <div className="text-[10px] text-teal-500 mt-0.5">уникальных</div>
//                   </div>

//                   <div className="bg-purple-50 border border-purple-200 rounded-xl p-2.5">
//                     <div className="text-[10px] md:text-xs text-purple-700 font-medium flex items-center gap-1">
//                       <Target size={12} /> Лидов
//                     </div>
//                     <div className="text-lg md:text-xl font-bold text-purple-800">
//                       {campaignStats.leads}
//                       <span className="text-xs font-normal text-purple-600 ml-1">
//                         ({campaignStats.leadRate}%)
//                       </span>
//                     </div>
//                     <div className="text-[10px] text-purple-500 mt-0.5">из ответивших</div>
//                   </div>
//                 </div>
//               )}

//               {/* ВОРОНКА */}
//               {campaignStats && campaignStats.sent > 0 && (
//                 <div className="bg-gradient-to-br from-blue-50 to-purple-50 border border-blue-200 rounded-xl p-3 md:p-4 mt-3">
//                   <div className="text-sm font-semibold text-gray-800 mb-3 flex items-center gap-2">
//                     Воронка кампании
//                   </div>

//                   <div className="space-y-2.5">
//                     <div>
//                       <div className="flex justify-between text-xs md:text-sm mb-1">
//                         <span className="text-gray-600 font-medium flex items-center gap-1.5">
//                           <Send size={13} /> Отправлено
//                         </span>
//                         <span className="font-bold text-gray-800">
//                           {campaignStats.sent}
//                           <span className="text-gray-400 font-normal ml-1">100%</span>
//                         </span>
//                       </div>
//                       <div className="w-full bg-white rounded-full h-2 overflow-hidden">
//                         <div className="h-full bg-gray-400" style={{ width: "100%" }} />
//                       </div>
//                     </div>

//                     <div>
//                       <div className="flex justify-between text-xs md:text-sm mb-1">
//                         <span className="text-gray-600 font-medium flex items-center gap-1.5">
//                           <MailOpen size={13} /> Открыто
//                         </span>
//                         <span className="font-bold text-cyan-700">
//                           {campaignStats.opened}
//                           <span className="text-gray-400 font-normal ml-1">
//                             {campaignStats.openFromSent}%
//                           </span>
//                         </span>
//                       </div>
//                       <div className="w-full bg-white rounded-full h-2 overflow-hidden">
//                         <div
//                           className="h-full bg-cyan-500 transition-all duration-500"
//                           style={{ width: `${campaignStats.openFromSent}%` }}
//                         />
//                       </div>
//                     </div>

//                     <div>
//                       <div className="flex justify-between text-xs md:text-sm mb-1">
//                         <span className="text-gray-600 font-medium flex items-center gap-1.5">
//                           <MessageSquare size={13} /> Ответили
//                         </span>
//                         <span className="font-bold text-teal-700">
//                           {campaignStats.replied}
//                           <span className="text-gray-400 font-normal ml-1">
//                             {campaignStats.replyFromOpened}% от открытых
//                           </span>
//                         </span>
//                       </div>
//                       <div className="w-full bg-white rounded-full h-2 overflow-hidden">
//                         <div
//                           className="h-full bg-teal-500 transition-all duration-500"
//                           style={{ width: `${campaignStats.replyFromOpened}%` }}
//                         />
//                       </div>
//                     </div>

//                     <div>
//                       <div className="flex justify-between text-xs md:text-sm mb-1">
//                         <span className="text-gray-600 font-medium flex items-center gap-1.5">
//                           <Target size={13} /> Стали лидами
//                         </span>
//                         <span className="font-bold text-purple-700">
//                           {campaignStats.leads}
//                           <span className="text-gray-400 font-normal ml-1">
//                             {campaignStats.leadFromReplied}% от ответивших
//                           </span>
//                         </span>
//                       </div>
//                       <div className="w-full bg-white rounded-full h-2 overflow-hidden">
//                         <div
//                           className="h-full bg-purple-500 transition-all duration-500"
//                           style={{ width: `${campaignStats.leadFromReplied}%` }}
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   <div className="mt-3 pt-3 border-t border-blue-200 flex items-center justify-between">
//                     <span className="text-xs text-gray-500">Итоговая конверсия в лида</span>
//                     <span className="text-2xl font-bold text-purple-700">
//                       {campaignStats.leadRate}%
//                     </span>
//                   </div>
//                 </div>
//               )}

//               <div className="flex flex-wrap gap-2 mt-2">
//                 {campaignDetails.status === "running" && (
//                   <>
//                     <button
//                       onClick={handlePause}
//                       className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-yellow-500 text-white hover:bg-yellow-600 transition text-sm inline-flex items-center justify-center gap-1.5"
//                     >
//                       <Pause size={14} /> Пауза
//                     </button>
//                     <button
//                       onClick={handleStop}
//                       className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-red-500 text-white hover:bg-red-600 transition text-sm inline-flex items-center justify-center gap-1.5"
//                     >
//                       <Square size={14} /> Остановить
//                     </button>
//                   </>
//                 )}
//                 {campaignDetails.status === "paused" && (
//                   <>
//                     <button
//                       onClick={handleResume}
//                       className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-green-500 text-white hover:bg-green-600 transition text-sm inline-flex items-center justify-center gap-1.5"
//                     >
//                       <Play size={14} /> Возобновить
//                     </button>
//                     <button
//                       onClick={handleStop}
//                       className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-red-500 text-white hover:bg-red-600 transition text-sm inline-flex items-center justify-center gap-1.5"
//                     >
//                       <Square size={14} /> Остановить
//                     </button>
//                   </>
//                 )}
//                 {(campaignDetails.status === "stopped" || campaignDetails.status === "completed") && (
//                   <span className="text-xs md:text-sm text-gray-500 inline-flex items-center gap-1.5">
//                     {campaignDetails.status === "completed"
//                       ? <><CheckCircle2 size={14} className="text-green-600" /> Завершена</>
//                       : <><Square size={14} className="text-red-600" /> Остановлена</>
//                     }
//                   </span>
//                 )}
//               </div>

//               {/* Desktop: emails table */}
//               <div className="hidden md:block overflow-x-auto rounded-xl border border-gray-200 max-h-60 overflow-y-auto mt-2">
//                 <table className="w-full text-sm">
//                   <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider sticky top-0 z-10">
//                     <tr>
//                       <th className="px-2 py-1 text-left">ПОЛУЧАТЕЛЬ</th>
//                       <th className="px-2 py-1 text-left">СТАТУС</th>
//                       <th className="px-2 py-1 text-left">SMTP ПОЧТА</th>
//                       <th className="px-2 py-1 text-left">ОТПРАВЛЕНО</th>
//                       <th className="px-2 py-1 text-left">ОТКРЫТО</th>
//                       <th className="px-2 py-1 text-left">ТЕМА</th>
//                       <th className="px-2 py-1 text-left">ТЕКСТ</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {displayedEmails.map((e) => {
//                       const t = findTracking(e.recipient_email);
//                       return (
//                         <tr key={e.id} className="border-t hover:bg-gray-50 transition">
//                           <td className="px-2 py-1">{e.recipient_email}</td>
//                           <td className="px-2 py-1 capitalize">{e.status}</td>
//                           <td className="px-2 py-1">{e.smtp_email}</td>
//                           <td className="px-2 py-1">{new Date(e.created_at).toLocaleString()}</td>
//                           <td className="px-2 py-1">
//                             {!t ? (
//                               <span className="text-gray-300">—</span>
//                             ) : t.opened_at ? (
//                               <span className="inline-flex items-center gap-1 text-emerald-600 text-xs">
//                                 <MailOpen size={12} /> {t.open_count}
//                                 {t.clicked_at && (
//                                   <span className="text-blue-600 inline-flex items-center gap-0.5 ml-1">
//                                     · <MousePointerClick size={11} />{t.click_count}
//                                   </span>
//                                 )}
//                               </span>
//                             ) : (
//                               <span className="text-gray-400 text-xs inline-flex items-center gap-1">
//                                 <Clock size={11} />
//                               </span>
//                             )}
//                           </td>
//                           <td
//                             className="px-2 py-1 min-w-[200px] max-w-[300px] break-words cursor-pointer hover:text-blue-600 transition"
//                             onClick={() => copyToClipboard(e.subject || campaignSubject)}
//                             title="Кликни чтобы скопировать тему"
//                           >
//                             {e.subject || campaignSubject}
//                           </td>
//                           <td
//                             className="px-2 py-1 min-w-[200px] max-w-[300px] break-words cursor-pointer hover:text-blue-600 transition"
//                             onClick={() => {
//                               const text = Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ");
//                               copyToClipboard(text);
//                             }}
//                             title="Кликни чтобы скопировать текст"
//                           >
//                             {Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ")}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Mobile: emails cards */}
//               <div className="md:hidden space-y-2 mt-2 max-h-80 overflow-y-auto">
//                 {displayedEmails.length === 0 && (
//                   <div className="text-xs text-gray-400 text-center py-4">Нет писем</div>
//                 )}
//                 {displayedEmails.map((e) => {
//                   const t = findTracking(e.recipient_email);
//                   return (
//                     <div key={e.id} className="bg-gray-50 rounded-xl p-2 text-xs">
//                       <div className="flex justify-between items-start gap-2 mb-1">
//                         <div className="font-medium text-gray-800 truncate flex-1">{e.recipient_email}</div>
//                         <span className={`px-1.5 py-0.5 rounded-full text-[10px] whitespace-nowrap ${
//                           e.status === "sent" ? "bg-green-100 text-green-700" :
//                           e.status === "failed" ? "bg-red-100 text-red-700" :
//                           "bg-gray-100 text-gray-700"
//                         }`}>
//                           {e.status}
//                         </span>
//                       </div>
//                       <div className="text-gray-500 mb-1 truncate">SMTP: {e.smtp_email}</div>
//                       <div className="text-gray-400 mb-1.5">{new Date(e.created_at).toLocaleString('ru-RU')}</div>

//                       {t && (
//                         <div className="flex gap-2 text-[11px] mb-1.5">
//                           {t.opened_at ? (
//                             <span className="text-emerald-600 inline-flex items-center gap-1">
//                               <MailOpen size={11} /> Открыто {t.open_count}×
//                             </span>
//                           ) : (
//                             <span className="text-gray-400 inline-flex items-center gap-1">
//                               <Clock size={11} /> Не открыто
//                             </span>
//                           )}
//                           {t.clicked_at && (
//                             <span className="text-blue-600 inline-flex items-center gap-1">
//                               <MousePointerClick size={11} /> {t.click_count}×
//                             </span>
//                           )}
//                         </div>
//                       )}

//                       <div
//                         className="text-blue-600 cursor-pointer truncate mb-0.5 inline-flex items-center gap-1 w-full"
//                         onClick={() => copyToClipboard(e.subject || campaignSubject)}
//                       >
//                         <Mail size={11} className="flex-shrink-0" />
//                         <span className="truncate">{e.subject || campaignSubject}</span>
//                       </div>
//                       <div
//                         className="text-gray-600 cursor-pointer line-clamp-2"
//                         onClick={() => {
//                           const text = Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ");
//                           copyToClipboard(text);
//                         }}
//                       >
//                         {Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ")}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* ===== ПРАВАЯ ПАНЕЛЬ ===== */}
//         <div className="w-full md:w-2/3 flex flex-col space-y-4">

// {/* DATABASE SELECT */}
// <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//   <h2 className="text-base md:text-lg font-semibold mb-2">База контактов</h2>
//   <select
//     value={selectedDbId || ""}
//     onChange={(e) => {
//       setSelectedDbId(e.target.value);
//       // Чистим исключения, если поменяли основную базу
//       setExcludeDbIds((prev) => prev.filter((id) => id !== Number(e.target.value)));
//     }}
//     className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
//   >
//     <option value="">Выберите базу</option>
//     {databases.map((db) => (
//       <option key={db.id} value={db.id}>
//         {db.name} ({db.contacts_count})
//       </option>
//     ))}
//   </select>

//   {/* Исключения */}
//   {selectedDbId && databases.length > 1 && (
//     <div className="mt-3 border-t pt-3">
//       <div className="flex items-center justify-between mb-2">
//         <h3 className="text-sm font-semibold text-gray-700">
//           Исключить контакты из баз:
//         </h3>
//         {excludeDbIds.length > 0 && (
//           <button
//             onClick={() => setExcludeDbIds([])}
//             className="text-xs text-blue-600 hover:text-blue-800 underline"
//           >
//             сбросить
//           </button>
//         )}
//       </div>

//       <div className="border rounded-xl p-2 max-h-40 overflow-y-auto bg-gray-50">
//         {databases
//           .filter((db) => db.id !== Number(selectedDbId))
//           .map((db) => (
//             <label
//               key={db.id}
//               className="flex items-center gap-2 p-1.5 hover:bg-white rounded cursor-pointer transition"
//             >
//               <input
//                 type="checkbox"
//                 checked={excludeDbIds.includes(db.id)}
//                 onChange={() => {
//                   setExcludeDbIds((prev) =>
//                     prev.includes(db.id)
//                       ? prev.filter((id) => id !== db.id)
//                       : [...prev, db.id]
//                   );
//                 }}
//                 className="w-4 h-4 flex-shrink-0"
//               />
//               <span className="text-xs text-gray-700 flex-1 truncate">
//                 {db.name}
//               </span>
//               <span className="text-[10px] text-gray-400 flex-shrink-0">
//                 {db.contacts_count} конт.
//               </span>
//             </label>
//           ))}
//       </div>

//       {/* Исключить уже получавших */}
//       <label className="flex items-start gap-2 mt-3 cursor-pointer">
//         <input
//           type="checkbox"
//           checked={excludeAlreadySent}
//           onChange={(e) => setExcludeAlreadySent(e.target.checked)}
//           className="w-4 h-4 mt-0.5 flex-shrink-0"
//         />
//         <span className="text-xs text-gray-700">
//           <b>Не отправлять тем, кто уже получал письма</b>
//           <span className="block text-[10px] text-gray-400 mt-0.5">
//             Проверяет все прошлые кампании — исключает тех, кому уже ушло письмо
//           </span>
//         </span>
//       </label>

//       <label className="flex items-start gap-2 mt-3 cursor-pointer">
//   <input
//     type="checkbox"
//     checked={excludeReplied}
//     onChange={(e) => setExcludeReplied(e.target.checked)}
//     className="w-4 h-4 mt-0.5 flex-shrink-0"
//   />
//   <span className="text-xs text-gray-700">
//     <b>Не отправлять тем, кто уже отвечал</b>
//     <span className="block text-[10px] text-gray-400 mt-0.5">
//       Исключает тех, от кого приходил хоть один ответ в любой переписке
//     </span>
//   </span>
// </label>

//       {/* Превью */}
//       {(excludeDbIds.length > 0 || excludeAlreadySent || excludeReplied) && (
//         <div className="mt-3 p-2 bg-blue-50 border border-blue-200 rounded-lg text-xs text-blue-800">
//           {excludeDbIds.length > 0 && (
//             <>Исключено баз: <b>{excludeDbIds.length}</b></>
//           )}
//           {excludeAlreadySent && (
//             <>{(excludeDbIds.length > 0) && " · "}Исключены получавшие</>
//           )}
//           {excludeReplied && (
//             <>{(excludeDbIds.length > 0 || excludeAlreadySent) && " · "}Исключены ответившие</>
//           )}
//         </div>
//       )}
//     </div>
//   )}
// </div>

//           {/* NORMAL CAMPAIGN */}
//           <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 space-y-3">
//             <h2 className="text-base md:text-lg font-semibold mb-1">Разовая классическая рассылка</h2>

//             <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 text-xs">
              
//               <div className="font-medium text-blue-900 mb-2">
//                 Используйте переменные для персонализации (клик — вставить в текст):
//               </div>
//               <div className="flex flex-wrap gap-1.5 mb-2">
//                 {['{{companyName}}', '{{name}}', '{{email}}', '{{city}}'].map((v) => (
//                   <code
//                     key={v}
//                     onClick={() => insertVariable(v)}
//                     title="Кликните, чтобы вставить в активное поле"
//                     className="bg-white px-2 py-0.5 rounded border border-blue-200 text-blue-800 font-mono text-[11px] cursor-pointer hover:bg-blue-100 hover:border-blue-400 active:scale-95 transition select-none"
//                   >
//                     {v}
//                   </code>
//                 ))}
//               </div>
//               <div className="text-blue-700 text-[11px] leading-relaxed">
//                 <b>Рандомизация:</b> разделяйте варианты через{' '}
//                 <code className="bg-white px-1 rounded border border-blue-200 font-mono">|</code>
//                 {' '}— будет выбран случайный
//               </div>
//             </div>

//             <input
//               placeholder="Название кампании: - Рассылка по юристам 24.09"
//               value={campaignName}
//               onChange={(e) => setCampaignName(e.target.value)}
//               className="w-full border rounded-xl px-3 py-2 text-sm"
//             />
            
//             <input
//               placeholder="Тема письма: - По поводу разработки ПО для {{name}}"
//               value={campaignSubject}
//               onChange={(e) => setCampaignSubject(e.target.value)}
//               className="w-full border rounded-xl px-3 py-2 text-sm"
//             />

//             <textarea
//               ref={campaignTextRef}
//               placeholder="Текст письма: Добрый день, {{name}} | Здравствуйте, {{name}}, ваша компания называется {{companyName}}?"
//               value={campaignTexts.join("|")}
//               onChange={(e) => setCampaignTexts(e.target.value.split("|"))}
//               className="w-full border rounded-xl px-3 py-2 text-sm"
//               rows={5}
//             />

//             <button
//               onClick={handleCreateCampaign}
//               className="w-full md:w-auto px-4 py-2 rounded-xl bg-green-600 text-white hover:bg-green-700 transition shadow-md text-sm inline-flex items-center justify-center gap-2"
//             >
//               <Send size={16} /> Запустить рассылку
//             </button>
//           </div>

//           {/* SEQUENCE CAMPAIGN */}
//           <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 space-y-2">
//             <h2 className="text-base md:text-lg font-semibold mb-1">Цепочка из 3-х писем (для профессионалов)</h2>
//             <input
//               placeholder="Название кампании"
//               value={sequenceName}
//               onChange={(e) => setSequenceName(e.target.value)}
//               className="w-full border rounded-xl px-3 py-2 text-sm"
//             />
//             {sequence.map((step, i) => (
//               <div key={i} className="mb-3">
//                 {i !== 0 && (
//                   <div className="flex gap-2 items-center flex-wrap text-xs bg-yellow-50 border border-yellow-200 rounded-lg px-2 py-1.5 mb-1.5">
//                     <span className="font-medium text-yellow-800 inline-flex items-center gap-1">
//                       <Clock size={12} /> Пауза перед письмом {i + 1}:
//                     </span>
//                     <input
//                       type="number"
//                       placeholder="Мин"
//                       value={step.delayMinutes || 0}
//                       onChange={(e) => updateSequence(i, "delayMinutes", Number(e.target.value))}
//                       className="border rounded-lg px-2 py-1 w-16 text-sm"
//                     />
//                     <span>мин</span>
//                     <input
//                       type="number"
//                       placeholder="Сек"
//                       value={step.delaySeconds || 0}
//                       onChange={(e) => updateSequence(i, "delaySeconds", Number(e.target.value))}
//                       className="border rounded-lg px-2 py-1 w-16 text-sm"
//                     />
//                     <span>сек</span>
//                     <span className="text-[10px] text-yellow-700 ml-auto">1 день = 1440 мин</span>
//                   </div>
//                 )}

//                 <div className="border rounded-xl p-2">
//                   <div className="font-semibold mb-1 text-sm">Письмо {i + 1}</div>
//                   <input
//                     placeholder="Тема письма"
//                     value={step.subject}
//                     onChange={(e) => updateSequence(i, "subject", e.target.value)}
//                     className="w-full border rounded-xl px-2 py-1 mb-1 text-sm"
//                   />
//                   <textarea
//                     ref={(el) => (sequenceRefs.current[i] = el)}
//                     placeholder="Текст"
//                     value={step.text}
//                     onChange={(e) => updateSequence(i, "text", e.target.value)}
//                     className="w-full border rounded-xl px-2 py-1 mb-1 text-sm"
//                     rows={3}
//                   />
//                 </div>
//               </div>
//             ))}
//             <button
//               onClick={handleCreateSequenceCampaign}
//               className="w-full md:w-auto px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition shadow-md text-sm inline-flex items-center justify-center gap-2"
//             >
//               <Send size={16} /> Запустить цепочку
//             </button>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         @keyframes fade-in {
//           from { opacity: 0; transform: translate(-50%, -20px); }
//           to { opacity: 1; transform: translate(-50%, 0); }
//         }
//         .animate-fade-in { animation: fade-in 0.3s ease-out; }
//       `}</style>
//     </div>
//   );
// }



// import React, { useState, useEffect } from "react";
// import { getSmtpAccounts } from "../api/api";
// import { getDatabasesWithCount } from "../api/databasesApi";
// import { useLoading } from "./useLoading";
// import { useAuth } from "./AuthContext";
// import axios from "axios";
// import {
//   Mail, MailOpen, MessageSquare, Target, MousePointerClick,
//   Send, Play, Pause, Square, CheckCircle2, Clock,
//   ChevronRight, Copy, FileText,
// } from "lucide-react";

// export default function Campaigns() {
//   const [smtpAccounts, setSmtpAccounts] = useState([]);
//   const [selectedSmtpIds, setSelectedSmtpIds] = useState([]);
//   const [databases, setDatabases] = useState([]);
//   const [campaigns, setCampaigns] = useState([]);
//   const [selectedCampaignId, setSelectedCampaignId] = useState(null);
//   const [campaignDetails, setCampaignDetails] = useState(null);
//   const [progress, setProgress] = useState(0);
//   const [sentEmails, setSentEmails] = useState([]);
//   const [emailFilter, setEmailFilter] = useState("all");
//   const [selectedDbId, setSelectedDbId] = useState(null);
//   const [excludeDbIds, setExcludeDbIds] = useState([]);
//   const [excludeAlreadySent, setExcludeAlreadySent] = useState(false);
//   const [excludeReplied, setExcludeReplied] = useState(false);
//   const [copiedText, setCopiedText] = useState(null);
//   const [nextSendTimer, setNextSendTimer] = useState(null);
//   const [timeLeft, setTimeLeft] = useState(null);

//   const [campaignName, setCampaignName] = useState("");
//   const [campaignSubject, setCampaignSubject] = useState("");
//   const [campaignTexts, setCampaignTexts] = useState([]);

//   const [campaignStats, setCampaignStats] = useState(null);
//   const [opensList, setOpensList] = useState([]);

//   const { user } = useAuth();
//   const isGold = user?.plan === "gold";

//   // ===== ШАБЛОНЫ =====
//   const [templates, setTemplates] = useState([]);
//   const [showTemplatesModal, setShowTemplatesModal] = useState(false);

//   const [sequenceName, setSequenceName] = useState("");
//   const [sequence, setSequence] = useState([
//     { subject: "", text: "", delayMinutes: 0, delaySeconds: 0 },
//     { subject: "", text: "", delayMinutes: 0, delaySeconds: 5 },
//     { subject: "", text: "", delayMinutes: 0, delaySeconds: 5 },
//   ]);

//   const { loading, withLoading } = useLoading();
//   const [selectAllSmtp, setSelectAllSmtp] = useState(false);

//   const campaignTextRef = React.useRef(null);
//   const sequenceRefs = React.useRef([]);

//   const updateSequence = (index, field, value) => {
//     const updated = [...sequence];
//     updated[index][field] = value;
//     setSequence(updated);
//   };

//   const copyToClipboard = (text) => {
//     if (!text) return;
//     if (navigator.clipboard && navigator.clipboard.writeText) {
//       navigator.clipboard.writeText(text)
//         .then(() => {
//           setCopiedText(text.slice(0, 50) + (text.length > 50 ? '...' : ''));
//           setTimeout(() => setCopiedText(null), 2000);
//         })
//         .catch(() => fallbackCopy(text));
//     } else {
//       fallbackCopy(text);
//     }
//   };

//   const fallbackCopy = (text) => {
//     const textarea = document.createElement('textarea');
//     textarea.value = text;
//     textarea.style.position = 'fixed';
//     textarea.style.opacity = '0';
//     document.body.appendChild(textarea);
//     textarea.select();
//     try {
//       document.execCommand('copy');
//       setCopiedText(text.slice(0, 50) + (text.length > 50 ? '...' : ''));
//       setTimeout(() => setCopiedText(null), 2000);
//     } catch (err) {
//       console.error('Ошибка копирования:', err);
//     }
//     document.body.removeChild(textarea);
//   };

//   const insertVariable = (variable) => {
//     const active = document.activeElement;

//     if (active && active.tagName === "TEXTAREA") {
//       const start = active.selectionStart ?? active.value.length;
//       const end = active.selectionEnd ?? active.value.length;
//       const newValue = active.value.slice(0, start) + variable + active.value.slice(end);

//       if (active === campaignTextRef.current) {
//         setCampaignTexts(newValue.split("|"));
//       } else {
//         const idx = sequenceRefs.current.indexOf(active);
//         if (idx !== -1) updateSequence(idx, "text", newValue);
//       }

//       requestAnimationFrame(() => {
//         active.focus();
//         const pos = start + variable.length;
//         active.setSelectionRange(pos, pos);
//       });
//       return;
//     }

//     const textarea = campaignTextRef.current;
//     if (textarea) {
//       const current = textarea.value;
//       const newValue = current + variable;
//       setCampaignTexts(newValue.split("|"));
//       requestAnimationFrame(() => {
//         textarea.focus();
//         textarea.setSelectionRange(newValue.length, newValue.length);
//       });
//     } else {
//       setCampaignTexts((prev) => {
//         const last = prev[prev.length - 1] || "";
//         return [...prev.slice(0, -1), last + variable];
//       });
//     }
//   };

//   const calculateNextSendTime = (sentEmailsList, campaign) => {
//     if (!campaign || !sentEmailsList.length) return null;
//     const lastSent = sentEmailsList
//       .filter(e => e.status === 'sent')
//       .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
//     if (!lastSent) return null;
//     const sentCount = sentEmailsList.filter(e => e.status === 'sent').length;
//     const defaultDelays = [0, 5, 10];
//     const delayIndex = Math.min(sentCount, defaultDelays.length - 1);
//     const delayMinutes = defaultDelays[delayIndex] || 5;
//     const nextSendTime = new Date(lastSent.created_at);
//     nextSendTime.setMinutes(nextSendTime.getMinutes() + delayMinutes);
//     return nextSendTime;
//   };

//   useEffect(() => {
//     async function load() {
//       try {
//         const smtpRes = await withLoading(() => getSmtpAccounts());
//         setSmtpAccounts(smtpRes.data);
//         const dbRes = await withLoading(() => getDatabasesWithCount());
//         setDatabases(dbRes.data);
//         const campaignsRes = await withLoading(() => axios.get("/api/campaigns"));
//         setCampaigns(campaignsRes.data);

//         // ===== ЗАГРУЗКА ШАБЛОНОВ =====
//         try {
//           const tplRes = await axios.get("/api/templates");
//           setTemplates(tplRes.data || []);
//         } catch (tplErr) {
//           console.error("Ошибка загрузки шаблонов:", tplErr);
//           // не рвём основной load — просто шаблонов не будет
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }
//     load();
//   }, []);

//   useEffect(() => {
//     if (!selectedCampaignId) {
//       setCampaignStats(null);
//       setOpensList([]);
//       return;
//     }
//     (async () => {
//       try {
//         const [statsRes, opensRes] = await Promise.all([
//           axios.get(`/api/campaigns/${selectedCampaignId}/stats`),
//           axios.get(`/api/campaigns/${selectedCampaignId}/opens`),
//         ]);
//         setCampaignStats(statsRes.data);
//         setOpensList(opensRes.data);
//       } catch (err) {
//         console.error("Ошибка загрузки статистики:", err);
//       }
//     })();
//   }, [selectedCampaignId, sentEmails.length]);

//   useEffect(() => {
//     if (!selectedCampaignId) return;
//     const interval = setInterval(async () => {
//       try {
//         const res = await axios.get(`/api/campaigns/${selectedCampaignId}`);
//         const data = res.data;
//         setCampaignDetails(data);
//         setProgress(Math.round(((data.sent_count + data.failed_count) / data.total_count) * 100));
//         const emailsRes = await axios.get(`/api/campaigns/${selectedCampaignId}/emails`);
//         setSentEmails(emailsRes.data);
//         const nextTime = calculateNextSendTime(emailsRes.data, data);
//         setNextSendTimer(nextTime);
//         setCampaigns((prev) =>
//           prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: data.status } : c)
//         );
//         if (data.status === "completed" || data.status === "stopped") clearInterval(interval);
//       } catch (err) {
//         console.error(err);
//       }
//     }, 2000);
//     return () => clearInterval(interval);
//   }, [selectedCampaignId]);

//   useEffect(() => {
//     if (!nextSendTimer) { setTimeLeft(null); return; }
//     const updateTimer = () => {
//       const now = new Date();
//       const diff = Math.max(0, Math.floor((nextSendTimer - now) / 1000));
//       if (diff <= 0) setTimeLeft(null);
//       else setTimeLeft(`${Math.floor(diff / 60)}:${(diff % 60).toString().padStart(2, '0')}`);
//     };
//     updateTimer();
//     const timerInterval = setInterval(updateTimer, 1000);
//     return () => clearInterval(timerInterval);
//   }, [nextSendTimer]);

//   const toggleSmtpSelect = (id) => {
//     setSelectedSmtpIds((prev) =>
//       prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
//     );
//   };

//   const toggleSelectAllSmtp = () => {
//     if (selectAllSmtp) setSelectedSmtpIds([]);
//     else setSelectedSmtpIds(smtpAccounts.map((s) => s.id));
//     setSelectAllSmtp(!selectAllSmtp);
//   };

//   const handleCreateCampaign = async () => {
//     if (!selectedDbId || !campaignName || !campaignSubject || !campaignTexts.length || !selectedSmtpIds.length) {
//       alert("Заполните все поля: выберите почты для работы, базу и напишите письмо");
//       return;
//     }
//     try {
//       const res = await withLoading(() =>
//         axios.post("/api/campaigns", {
//           databaseId: Number(selectedDbId),
//           name: campaignName,
//           subject: campaignSubject,
//           texts: campaignTexts,
//           smtpIds: selectedSmtpIds,
//           excludeDatabaseIds: excludeDbIds.map(Number),
//           excludeAlreadySent,
//           excludeReplied,
//         })
//       );
//       const newCampaign = res.data;

//       if (newCampaign.requiresModeration) {
//   alert("⏳ Кампания отправлена на модерацию. Вы получите уведомление после одобрения.");
// }

//       setCampaigns([newCampaign, ...campaigns]);
//       setSelectedCampaignId(newCampaign.campaignId);
//       setExcludeDbIds([]);
//       setExcludeAlreadySent(false);
//       setExcludeReplied(false);
//     } catch (err) {
//       console.error(err.response?.data || err);
//       alert(`Ошибка: ${err.response?.data?.error || err.message}`);
//     }
//   };

//   // ===== ПРИМЕНИТЬ ШАБЛОН =====
//   const applyTemplate = (tpl) => {
//     if (!tpl) return;
//     if (campaignSubject || campaignTexts.length > 0) {
//       if (!window.confirm("Заменить текущую тему и текст шаблоном?")) return;
//     }
//     setCampaignSubject(tpl.subject || "");
//     const bodyText = tpl.body || "";
//     // если в шаблоне есть разделитель "|" — разбиваем на варианты
//     setCampaignTexts(bodyText.includes("|") ? bodyText.split("|") : [bodyText]);
//     setShowTemplatesModal(false);
//   };

//   const handleCreateSequenceCampaign = async () => {
//     if (!selectedDbId || !sequenceName.trim() || selectedSmtpIds.length === 0) {
//       alert("Заполните базу, название и SMTP");
//       return;
//     }
//     if (!sequence.every((s) => s.subject.trim() && s.text.trim())) {
//       alert("Заполните subject и text для всех писем");
//       return;
//     }
//     const defaultSubject = sequence[0]?.subject || "No Subject";
//     try {
//       const res = await withLoading(() =>
//         axios.post("/api/campaigns/sequence", {
//           databaseId: Number(selectedDbId),
//           name: sequenceName,
//           smtpIds: selectedSmtpIds,
//           sequence,
//           subject: defaultSubject,
//         })
//       );
//       const newCampaign = res.data;
//       const delays = sequence.slice(1).map(s =>
//         s.delayMinutes > 0 ? `${s.delayMinutes}м` : `${s.delaySeconds}с`
//       );
//       const sequenceInfo = ` (${sequence.length} письма, паузы: ${delays.join(', ')})`;
//       setCampaigns((prev) => [
//         { campaignId: newCampaign.campaignId, name: sequenceName + sequenceInfo, status: "running", isSequence: true, sequenceInfo },
//         ...prev,
//       ]);
//       setSelectedCampaignId(newCampaign.campaignId);
//       setExcludeDbIds([]);
//       setExcludeAlreadySent(false);
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.error || "Ошибка запуска sequence");
//     }
//   };

//   const handlePause = async () => {
//     if (!selectedCampaignId) return;
//     try {
//       await withLoading(() => axios.post(`/api/campaigns/${selectedCampaignId}/pause`));
//       setCampaignDetails((prev) => ({ ...prev, status: "paused" }));
//       setCampaigns((prev) => prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: "paused" } : c));
//     } catch (err) {
//       alert(err.response?.data?.error || "Ошибка при постановке на паузу");
//     }
//   };

//   const handleResume = async () => {
//     if (!selectedCampaignId) return;
//     try {
//       await withLoading(() => axios.post(`/api/campaigns/${selectedCampaignId}/resume`));
//       setCampaignDetails((prev) => ({ ...prev, status: "running" }));
//       setCampaigns((prev) => prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: "running" } : c));
//     } catch (err) {
//       alert(err.response?.data?.error || "Ошибка при возобновлении");
//     }
//   };

//   const handleStop = async () => {
//     if (!selectedCampaignId) return;
//     try {
//       await withLoading(() => axios.post(`/api/campaigns/${selectedCampaignId}/stop`));
//       setCampaignDetails((prev) => ({ ...prev, status: "stopped" }));
//       setCampaigns((prev) => prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: "stopped" } : c));
//     } catch (err) {
//       alert(err.response?.data?.error || "Ошибка при остановке");
//     }
//   };

//   const displayedEmails = sentEmails.filter((e) => {
//     if (emailFilter === "all") return true;
//     if (emailFilter === "sent") return e.status === "sent";
//     if (emailFilter === "failed") return e.status === "failed";
//     return true;
//   });

//   const StatusBadge = ({ status }) => {
//     if (status === "paused") return (
//       <span className="inline-flex items-center gap-1 text-yellow-600">
//         <Pause size={12} /> На паузе
//       </span>
//     );
//     if (status === "running") return (
//       <span className="inline-flex items-center gap-1 text-green-600">
//         <Play size={12} /> Выполняется
//       </span>
//     );
//     if (status === "completed") return (
//       <span className="inline-flex items-center gap-1 text-green-600">
//         <CheckCircle2 size={12} /> Завершена
//       </span>
//     );
//     if (status === "stopped") return (
//       <span className="inline-flex items-center gap-1 text-red-600">
//         <Square size={12} /> Остановлена
//       </span>
//     );
//     return <span className="text-gray-500">{status}</span>;
//   };

//   const findTracking = (email) => opensList.find(o => o.recipient_email === email);

//   return (
//     <div className="min-h-screen bg-gray-50 p-3 md:p-4">
//       {loading && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="w-20 h-20 border-8 border-gray-200 border-t-8 border-t-blue-600 rounded-full animate-spin" />
//         </div>
//       )}

//       {copiedText && (
//         <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-4 py-2 rounded-xl shadow-lg z-50 text-sm inline-flex items-center gap-2">
//           <CheckCircle2 size={14} /> Скопировано
//         </div>
//       )}

//       <h1 className="text-xl md:text-2xl font-bold mb-4 flex items-center gap-2">
//         <Send size={22} className="text-blue-600" /> Email кампании
//       </h1>

//       <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">

//         {/* ===== ЛЕВАЯ ПАНЕЛЬ ===== */}
//         <div className="w-full md:w-1/2 flex flex-col space-y-4">

//           {/* SMTP */}
//           <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//             <h2 className="text-base md:text-lg font-semibold mb-2 flex items-center gap-2">
//               Выберите почты для рассылок
//             </h2>

//             <div className="hidden md:block overflow-auto border rounded-xl">
//               <table className="w-full text-sm">
//                 <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider">
//                   <tr>
//                     <th className="px-2 py-1 text-left">
//                       <input type="checkbox" checked={selectAllSmtp} onChange={toggleSelectAllSmtp} />
//                     </th>
//                     <th className="px-2 py-1 text-left">Email</th>
//                     <th className="px-2 py-1 text-left">Сегодня</th>
//                     <th className="px-2 py-1 text-left">Всего</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {smtpAccounts.map((s) => (
//                     <tr key={s.id} className="border-t hover:bg-gray-50 transition">
//                       <td className="px-2 py-1">
//                         <input
//                           type="checkbox"
//                           checked={selectedSmtpIds.includes(s.id)}
//                           onChange={() => toggleSmtpSelect(s.id)}
//                         />
//                       </td>
//                       <td className="px-2 py-1 font-medium text-gray-800">{s.email}</td>
//                       <td className="px-2 py-1 text-gray-600">{s.sentToday || 0}</td>
//                       <td className="px-2 py-1 text-gray-600">{s.sentTotal || 0}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             <div className="md:hidden space-y-2">
//               {smtpAccounts.length > 0 && (
//                 <div className="flex items-center gap-2 px-2 py-1.5 bg-gray-50 rounded-lg">
//                   <input
//                     type="checkbox"
//                     checked={selectAllSmtp}
//                     onChange={toggleSelectAllSmtp}
//                     className="w-4 h-4"
//                   />
//                   <span className="text-xs text-gray-600">Выбрать все</span>
//                 </div>
//               )}
//               {smtpAccounts.length === 0 && (
//                 <div className="text-xs text-gray-400 text-center py-4">Нет SMTP</div>
//               )}
//               {smtpAccounts.map((s) => (
//                 <label
//                   key={s.id}
//                   className={`flex items-start gap-2 p-2 rounded-lg cursor-pointer transition ${
//                     selectedSmtpIds.includes(s.id) ? 'bg-blue-50 ring-1 ring-blue-400' : 'bg-gray-50'
//                   }`}
//                 >
//                   <input
//                     type="checkbox"
//                     checked={selectedSmtpIds.includes(s.id)}
//                     onChange={() => toggleSmtpSelect(s.id)}
//                     className="mt-0.5 w-4 h-4 flex-shrink-0"
//                   />
//                   <div className="flex-1 min-w-0">
//                     <div className="text-xs font-medium text-gray-800 truncate">{s.email}</div>
//                     <div className="flex gap-3 mt-0.5 text-[11px] text-gray-500">
//                       <span>Сегодня: {s.sentToday || 0}</span>
//                       <span>Всего: {s.sentTotal || 0}</span>
//                     </div>
//                   </div>
//                 </label>
//               ))}
//             </div>
//           </div>

//           {/* ===== CAMPAIGNS LIST ===== */}
//           <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//             <h2 className="text-base md:text-lg font-semibold mb-2 flex items-center gap-2">
//               Все кампании
//             </h2>
//             <div className="flex flex-col space-y-1.5 max-h-72 md:max-h-80 overflow-y-auto">
//               {campaigns.length === 0 && (
//                 <div className="text-xs text-gray-400 text-center py-4">Нет кампаний</div>
//               )}
//               {campaigns.map((c) => {
//                 const dateStr = c.created_at
//                   ? new Date(c.created_at).toLocaleString('ru-RU', {
//                       day: '2-digit',
//                       month: '2-digit',
//                       hour: '2-digit',
//                       minute: '2-digit',
//                     })
//                   : '—';

//                 const sent = c.sent ?? c.sent_count ?? 0;
//                 const opened = c.opened ?? 0;
//                 const replied = c.replied ?? 0;
//                 const leads = c.leads ?? 0;
//                 const total = c.total ?? c.total_count ?? 0;

//                 const isActive = c.campaignId === selectedCampaignId;

//                 return (
//                   <button
//                     key={c.campaignId}
//                     onClick={() => setSelectedCampaignId(c.campaignId)}
//                     className={`w-full text-left px-3 py-3 rounded-xl transition flex items-center gap-3 ${
//                       isActive
//                         ? "bg-blue-50 border-2 border-blue-500"
//                         : "hover:bg-gray-50 border-2 border-transparent"
//                     }`}
//                   >
//                     <div className="flex-1 min-w-0">
//                       <div className="flex items-center gap-2 flex-wrap">
//                         <span className="font-semibold text-sm text-gray-800 truncate">
//                           #{c.campaignId} — {c.name}
//                         </span>
//                         <span className="text-xs flex-shrink-0">
//                           <StatusBadge status={c.status} />
//                         </span>
//                           {c.moderation_status === "pending" && (
//                           <span className="text-[10px] bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full font-medium">
//                             ⏳ На модерации
//                           </span>
//                         )}
//                         {c.moderation_status === "rejected" && (
//                           <span className="text-[10px] bg-red-100 text-red-800 px-2 py-0.5 rounded-full font-medium">
//                             ❌ Отклонена
//                           </span>
//                         )}
//                         {c.status === "running" && (
//                           <div className="w-3 h-3 border-2 border-blue-500 border-t-transparent rounded-full animate-spin flex-shrink-0" />
//                         )}
//                         {c.isSequence && c.status === "running" && timeLeft && (
//                           <span className="bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded-full text-[10px] flex-shrink-0 inline-flex items-center gap-1">
//                             <Clock size={10} /> {timeLeft}
//                           </span>
//                         )}
//                       </div>

//                       <div className="text-xs text-gray-500 mt-1 flex items-center flex-wrap gap-x-2 gap-y-0.5">
//                         <span className="inline-flex items-center gap-1">
//                           <Send size={11} className="text-gray-400" />
//                           <b className="text-gray-400">{sent}</b>
//                           {total > 0 && (
//                             <span className="text-gray-400">
//                               из <b>{total}</b>
//                             </span>
//                           )}
//                         </span>
//                         <span className="text-gray-300">·</span>
//                         <span className="inline-flex items-center gap-1">
//                           <MailOpen size={11} className="text-gray-400" />
//                           <b className="text-gray-400">{opened} открыли</b>
//                         </span>
//                         <span className="text-gray-300">·</span>
//                         <span className="inline-flex items-center gap-1">
//                           <MessageSquare size={11} className="text-gray-400" />
//                           <b className="text-gray-400">{replied} ответили</b>
//                         </span>
//                         <span className="text-gray-300">·</span>
//                         <span className="inline-flex items-center gap-1">
//                           <Target size={11} className="text-purple-500" />
//                           <b className="text-purple-600">{leads} лидов</b>
//                         </span>
//                         <span className="text-gray-300">·</span>
//                         <span className="text-gray-400">{dateStr}</span>
//                       </div>
//                     </div>

//                     <ChevronRight
//                       size={18}
//                       className={`flex-shrink-0 transition ${
//                         isActive ? "text-blue-500" : "text-gray-300"
//                       }`}
//                     />
//                   </button>
//                 );
//               })}
//             </div>
//           </div>

//           {/* CAMPAIGN DETAILS */}
//           {campaignDetails.moderation_status === "rejected" && (
//   <div className="bg-red-50 border border-red-200 rounded-xl p-3 mb-3">
//     <div className="text-sm font-semibold text-red-800 mb-2 flex items-center gap-2">
//       ❌ Кампания отклонена модератором
//     </div>
//     {campaignDetails.moderation_comment && (
//       <div className="text-xs text-red-700 bg-white rounded-lg p-2 mb-3 border border-red-100">
//         <b>Комментарий:</b> {campaignDetails.moderation_comment}
//       </div>
//     )}
//     <div className="flex flex-wrap gap-2">
//       <button
//         onClick={() => openEditModal(campaignDetails)}
//         className="px-3 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition text-sm font-medium"
//       >
//         ✏️ Редактировать
//       </button>
//       <button
//         onClick={handleResubmit}
//         disabled={savingId === campaignDetails.id}
//         className="px-3 py-2 rounded-xl bg-green-600 text-white hover:bg-green-700 transition text-sm font-medium disabled:opacity-50"
//       >
//         🔄 Отправить на модерацию повторно
//       </button>
//     </div>
//   </div>
// )}
//           {campaignDetails && (
//             <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 space-y-2">
//               <h2 className="text-base md:text-lg font-semibold mb-2">
//                 Детали #{selectedCampaignId}
//               </h2>

//               <div className="text-xs md:text-sm text-gray-600 flex items-center gap-2 flex-wrap">
//                 <span className="font-semibold">Статус:</span>
//                 <span className="capitalize"><StatusBadge status={campaignDetails.status} /></span>
//                 {campaignDetails.status === "running" && (
//                   <div className="w-3 h-3 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
//                 )}
//               </div>

//               <div className="w-full bg-gray-200 h-2 rounded-full mb-2 overflow-hidden">
//                 <div
//                   className={`h-2 transition-all duration-500 ${
//                     campaignDetails.status === "paused" ? "bg-yellow-500" :
//                     campaignDetails.status === "completed" ? "bg-blue-500" :
//                     campaignDetails.status === "stopped" ? "bg-red-500" :
//                     "bg-green-600"
//                   }`}
//                   style={{ width: `${progress}%` }}
//                 />
//               </div>

//               <div className="text-xs md:text-sm text-gray-600">
//                 {campaignDetails.sent_count} отправлено / {campaignDetails.failed_count} ошибок / {campaignDetails.total_count} всего
//               </div>

//               {campaignStats && campaignStats.sent > 0 && (
//                 <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-3">
//                   <div className="bg-blue-50 border border-blue-200 rounded-xl p-2.5">
//                     <div className="text-[10px] md:text-xs text-blue-700 font-medium flex items-center gap-1">
//                       <MailOpen size={12} /> Открыто
//                     </div>
//                     <div className="text-lg md:text-xl font-bold text-blue-800">
//                       {campaignStats.opened}
//                       <span className="text-xs font-normal text-blue-600 ml-1">
//                         ({campaignStats.openRate}%)
//                       </span>
//                     </div>
//                     <div className="text-[10px] text-blue-500 mt-0.5">
//                       всего открытий: {campaignStats.totalOpens}
//                     </div>
//                   </div>

//                   <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-2.5">
//                     <div className="text-[10px] md:text-xs text-emerald-700 font-medium flex items-center gap-1">
//                       <MousePointerClick size={12} /> Кликов
//                     </div>
//                     <div className="text-lg md:text-xl font-bold text-emerald-800">
//                       {campaignStats.clicked}
//                       <span className="text-xs font-normal text-emerald-600 ml-1">
//                         ({campaignStats.clickRate}%)
//                       </span>
//                     </div>
//                     <div className="text-[10px] text-emerald-500 mt-0.5">
//                       всего кликов: {campaignStats.totalClicks}
//                     </div>
//                   </div>

//                   <div className="bg-teal-50 border border-teal-200 rounded-xl p-2.5">
//                     <div className="text-[10px] md:text-xs text-teal-700 font-medium flex items-center gap-1">
//                       <MessageSquare size={12} /> Ответили
//                     </div>
//                     <div className="text-lg md:text-xl font-bold text-teal-800">
//                       {campaignStats.replied}
//                       <span className="text-xs font-normal text-teal-600 ml-1">
//                         ({campaignStats.replyRate}%)
//                       </span>
//                     </div>
//                     <div className="text-[10px] text-teal-500 mt-0.5">уникальных</div>
//                   </div>

//                   <div className="bg-purple-50 border border-purple-200 rounded-xl p-2.5">
//                     <div className="text-[10px] md:text-xs text-purple-700 font-medium flex items-center gap-1">
//                       <Target size={12} /> Лидов
//                     </div>
//                     <div className="text-lg md:text-xl font-bold text-purple-800">
//                       {campaignStats.leads}
//                       <span className="text-xs font-normal text-purple-600 ml-1">
//                         ({campaignStats.leadRate}%)
//                       </span>
//                     </div>
//                     <div className="text-[10px] text-purple-500 mt-0.5">из ответивших</div>
//                   </div>
//                 </div>
//               )}

//               {campaignStats && campaignStats.sent > 0 && (
//                 <div className="bg-gradient-to-br from-blue-50 to-purple-50 border border-blue-200 rounded-xl p-3 md:p-4 mt-3">
//                   <div className="text-sm font-semibold text-gray-800 mb-3 flex items-center gap-2">
//                     Воронка кампании
//                   </div>

//                   <div className="space-y-2.5">
//                     <div>
//                       <div className="flex justify-between text-xs md:text-sm mb-1">
//                         <span className="text-gray-600 font-medium flex items-center gap-1.5">
//                           <Send size={13} /> Отправлено
//                         </span>
//                         <span className="font-bold text-gray-800">
//                           {campaignStats.sent}
//                           <span className="text-gray-400 font-normal ml-1">100%</span>
//                         </span>
//                       </div>
//                       <div className="w-full bg-white rounded-full h-2 overflow-hidden">
//                         <div className="h-full bg-gray-400" style={{ width: "100%" }} />
//                       </div>
//                     </div>

//                     <div>
//                       <div className="flex justify-between text-xs md:text-sm mb-1">
//                         <span className="text-gray-600 font-medium flex items-center gap-1.5">
//                           <MailOpen size={13} /> Открыто
//                         </span>
//                         <span className="font-bold text-cyan-700">
//                           {campaignStats.opened}
//                           <span className="text-gray-400 font-normal ml-1">
//                             {campaignStats.openFromSent}%
//                           </span>
//                         </span>
//                       </div>
//                       <div className="w-full bg-white rounded-full h-2 overflow-hidden">
//                         <div
//                           className="h-full bg-cyan-500 transition-all duration-500"
//                           style={{ width: `${campaignStats.openFromSent}%` }}
//                         />
//                       </div>
//                     </div>

//                     <div>
//                       <div className="flex justify-between text-xs md:text-sm mb-1">
//                         <span className="text-gray-600 font-medium flex items-center gap-1.5">
//                           <MessageSquare size={13} /> Ответили
//                         </span>
//                         <span className="font-bold text-teal-700">
//                           {campaignStats.replied}
//                           <span className="text-gray-400 font-normal ml-1">
//                             {campaignStats.replyFromOpened}% от открытых
//                           </span>
//                         </span>
//                       </div>
//                       <div className="w-full bg-white rounded-full h-2 overflow-hidden">
//                         <div
//                           className="h-full bg-teal-500 transition-all duration-500"
//                           style={{ width: `${campaignStats.replyFromOpened}%` }}
//                         />
//                       </div>
//                     </div>

//                     <div>
//                       <div className="flex justify-between text-xs md:text-sm mb-1">
//                         <span className="text-gray-600 font-medium flex items-center gap-1.5">
//                           <Target size={13} /> Стали лидами
//                         </span>
//                         <span className="font-bold text-purple-700">
//                           {campaignStats.leads}
//                           <span className="text-gray-400 font-normal ml-1">
//                             {campaignStats.leadFromReplied}% от ответивших
//                           </span>
//                         </span>
//                       </div>
//                       <div className="w-full bg-white rounded-full h-2 overflow-hidden">
//                         <div
//                           className="h-full bg-purple-500 transition-all duration-500"
//                           style={{ width: `${campaignStats.leadFromReplied}%` }}
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   <div className="mt-3 pt-3 border-t border-blue-200 flex items-center justify-between">
//                     <span className="text-xs text-gray-500">Итоговая конверсия в лида</span>
//                     <span className="text-2xl font-bold text-purple-700">
//                       {campaignStats.leadRate}%
//                     </span>
//                   </div>
//                 </div>
//               )}

//               <div className="flex flex-wrap gap-2 mt-2">
//                 {campaignDetails.status === "running" && (
//                   <>
//                     <button
//                       onClick={handlePause}
//                       className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-yellow-500 text-white hover:bg-yellow-600 transition text-sm inline-flex items-center justify-center gap-1.5"
//                     >
//                       <Pause size={14} /> Пауза
//                     </button>
//                     <button
//                       onClick={handleStop}
//                       className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-red-500 text-white hover:bg-red-600 transition text-sm inline-flex items-center justify-center gap-1.5"
//                     >
//                       <Square size={14} /> Остановить
//                     </button>
//                   </>
//                 )}
//                 {campaignDetails.status === "paused" && (
//                   <>
//                     <button
//                       onClick={handleResume}
//                       className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-green-500 text-white hover:bg-green-600 transition text-sm inline-flex items-center justify-center gap-1.5"
//                     >
//                       <Play size={14} /> Возобновить
//                     </button>
//                     <button
//                       onClick={handleStop}
//                       className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-red-500 text-white hover:bg-red-600 transition text-sm inline-flex items-center justify-center gap-1.5"
//                     >
//                       <Square size={14} /> Остановить
//                     </button>
//                   </>
//                 )}
//                 {(campaignDetails.status === "stopped" || campaignDetails.status === "completed") && (
//                   <span className="text-xs md:text-sm text-gray-500 inline-flex items-center gap-1.5">
//                     {campaignDetails.status === "completed"
//                       ? <><CheckCircle2 size={14} className="text-green-600" /> Завершена</>
//                       : <><Square size={14} className="text-red-600" /> Остановлена</>
//                     }
//                   </span>
//                 )}
//               </div>

//               {/* Desktop: emails table */}
//               <div className="hidden md:block overflow-x-auto rounded-xl border border-gray-200 max-h-60 overflow-y-auto mt-2">
//                 <table className="w-full text-sm">
//                   <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider sticky top-0 z-10">
//                     <tr>
//                       <th className="px-2 py-1 text-left">ПОЛУЧАТЕЛЬ</th>
//                       <th className="px-2 py-1 text-left">СТАТУС</th>
//                       <th className="px-2 py-1 text-left">SMTP ПОЧТА</th>
//                       <th className="px-2 py-1 text-left">ОТПРАВЛЕНО</th>
//                       <th className="px-2 py-1 text-left">ОТКРЫТО</th>
//                       <th className="px-2 py-1 text-left">ТЕМА</th>
//                       <th className="px-2 py-1 text-left">ТЕКСТ</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {displayedEmails.map((e) => {
//                       const t = findTracking(e.recipient_email);
//                       return (
//                         <tr key={e.id} className="border-t hover:bg-gray-50 transition">
//                           <td className="px-2 py-1">{e.recipient_email}</td>
//                           <td className="px-2 py-1 capitalize">{e.status}</td>
//                           <td className="px-2 py-1">{e.smtp_email}</td>
//                           <td className="px-2 py-1">{new Date(e.created_at).toLocaleString()}</td>
//                           <td className="px-2 py-1">
//                             {!t ? (
//                               <span className="text-gray-300">—</span>
//                             ) : t.opened_at ? (
//                               <span className="inline-flex items-center gap-1 text-emerald-600 text-xs">
//                                 <MailOpen size={12} /> {t.open_count}
//                                 {t.clicked_at && (
//                                   <span className="text-blue-600 inline-flex items-center gap-0.5 ml-1">
//                                     · <MousePointerClick size={11} />{t.click_count}
//                                   </span>
//                                 )}
//                               </span>
//                             ) : (
//                               <span className="text-gray-400 text-xs inline-flex items-center gap-1">
//                                 <Clock size={11} />
//                               </span>
//                             )}
//                           </td>
//                           <td
//                             className="px-2 py-1 min-w-[200px] max-w-[300px] break-words cursor-pointer hover:text-blue-600 transition"
//                             onClick={() => copyToClipboard(e.subject || campaignSubject)}
//                             title="Кликни чтобы скопировать тему"
//                           >
//                             {e.subject || campaignSubject}
//                           </td>
//                           <td
//                             className="px-2 py-1 min-w-[200px] max-w-[300px] break-words cursor-pointer hover:text-blue-600 transition"
//                             onClick={() => {
//                               const text = Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ");
//                               copyToClipboard(text);
//                             }}
//                             title="Кликни чтобы скопировать текст"
//                           >
//                             {Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ")}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Mobile: emails cards */}
//               <div className="md:hidden space-y-2 mt-2 max-h-80 overflow-y-auto">
//                 {displayedEmails.length === 0 && (
//                   <div className="text-xs text-gray-400 text-center py-4">Нет писем</div>
//                 )}
//                 {displayedEmails.map((e) => {
//                   const t = findTracking(e.recipient_email);
//                   return (
//                     <div key={e.id} className="bg-gray-50 rounded-xl p-2 text-xs">
//                       <div className="flex justify-between items-start gap-2 mb-1">
//                         <div className="font-medium text-gray-800 truncate flex-1">{e.recipient_email}</div>
//                         <span className={`px-1.5 py-0.5 rounded-full text-[10px] whitespace-nowrap ${
//                           e.status === "sent" ? "bg-green-100 text-green-700" :
//                           e.status === "failed" ? "bg-red-100 text-red-700" :
//                           "bg-gray-100 text-gray-700"
//                         }`}>
//                           {e.status}
//                         </span>
//                       </div>
//                       <div className="text-gray-500 mb-1 truncate">SMTP: {e.smtp_email}</div>
//                       <div className="text-gray-400 mb-1.5">{new Date(e.created_at).toLocaleString('ru-RU')}</div>

//                       {t && (
//                         <div className="flex gap-2 text-[11px] mb-1.5">
//                           {t.opened_at ? (
//                             <span className="text-emerald-600 inline-flex items-center gap-1">
//                               <MailOpen size={11} /> Открыто {t.open_count}×
//                             </span>
//                           ) : (
//                             <span className="text-gray-400 inline-flex items-center gap-1">
//                               <Clock size={11} /> Не открыто
//                             </span>
//                           )}
//                           {t.clicked_at && (
//                             <span className="text-blue-600 inline-flex items-center gap-1">
//                               <MousePointerClick size={11} /> {t.click_count}×
//                             </span>
//                           )}
//                         </div>
//                       )}

//                       <div
//                         className="text-blue-600 cursor-pointer truncate mb-0.5 inline-flex items-center gap-1 w-full"
//                         onClick={() => copyToClipboard(e.subject || campaignSubject)}
//                       >
//                         <Mail size={11} className="flex-shrink-0" />
//                         <span className="truncate">{e.subject || campaignSubject}</span>
//                       </div>
//                       <div
//                         className="text-gray-600 cursor-pointer line-clamp-2"
//                         onClick={() => {
//                           const text = Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ");
//                           copyToClipboard(text);
//                         }}
//                       >
//                         {Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ")}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* ===== ПРАВАЯ ПАНЕЛЬ ===== */}
//         <div className="w-full md:w-2/3 flex flex-col space-y-4">

// {/* DATABASE SELECT */}
// <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
//   <h2 className="text-base md:text-lg font-semibold mb-2">База контактов</h2>
//   <select
//     value={selectedDbId || ""}
//     onChange={(e) => {
//       setSelectedDbId(e.target.value);
//       setExcludeDbIds((prev) => prev.filter((id) => id !== Number(e.target.value)));
//     }}
//     className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
//   >
//     <option value="">Выберите базу</option>
//     {databases.map((db) => (
//       <option key={db.id} value={db.id}>
//         {db.name} ({db.contacts_count})
//       </option>
//     ))}
//   </select>

//   {selectedDbId && databases.length > 1 && (
//     <div className="mt-3 border-t pt-3">
//       <div className="flex items-center justify-between mb-2">
//         <h3 className="text-sm font-semibold text-gray-700">
//           Исключить контакты из баз:
//         </h3>
//         {excludeDbIds.length > 0 && (
//           <button
//             onClick={() => setExcludeDbIds([])}
//             className="text-xs text-blue-600 hover:text-blue-800 underline"
//           >
//             сбросить
//           </button>
//         )}
//       </div>

//       <div className="border rounded-xl p-2 max-h-40 overflow-y-auto bg-gray-50">
//         {databases
//           .filter((db) => db.id !== Number(selectedDbId))
//           .map((db) => (
//             <label
//               key={db.id}
//               className="flex items-center gap-2 p-1.5 hover:bg-white rounded cursor-pointer transition"
//             >
//               <input
//                 type="checkbox"
//                 checked={excludeDbIds.includes(db.id)}
//                 onChange={() => {
//                   setExcludeDbIds((prev) =>
//                     prev.includes(db.id)
//                       ? prev.filter((id) => id !== db.id)
//                       : [...prev, db.id]
//                   );
//                 }}
//                 className="w-4 h-4 flex-shrink-0"
//               />
//               <span className="text-xs text-gray-700 flex-1 truncate">
//                 {db.name}
//               </span>
//               <span className="text-[10px] text-gray-400 flex-shrink-0">
//                 {db.contacts_count} конт.
//               </span>
//             </label>
//           ))}
//       </div>

//       <label className="flex items-start gap-2 mt-3 cursor-pointer">
//         <input
//           type="checkbox"
//           checked={excludeAlreadySent}
//           onChange={(e) => setExcludeAlreadySent(e.target.checked)}
//           className="w-4 h-4 mt-0.5 flex-shrink-0"
//         />
//         <span className="text-xs text-gray-700">
//           <b>Не отправлять тем, кто уже получал письма</b>
//           <span className="block text-[10px] text-gray-400 mt-0.5">
//             Проверяет все прошлые кампании — исключает тех, кому уже ушло письмо
//           </span>
//         </span>
//       </label>

//       <label className="flex items-start gap-2 mt-3 cursor-pointer">
//         <input
//           type="checkbox"
//           checked={excludeReplied}
//           onChange={(e) => setExcludeReplied(e.target.checked)}
//           className="w-4 h-4 mt-0.5 flex-shrink-0"
//         />
//         <span className="text-xs text-gray-700">
//           <b>Не отправлять тем, кто уже отвечал</b>
//           <span className="block text-[10px] text-gray-400 mt-0.5">
//             Исключает тех, от кого приходил хоть один ответ в любой переписке
//           </span>
//         </span>
//       </label>

//       {(excludeDbIds.length > 0 || excludeAlreadySent || excludeReplied) && (
//         <div className="mt-3 p-2 bg-blue-50 border border-blue-200 rounded-lg text-xs text-blue-800">
//           {excludeDbIds.length > 0 && (
//             <>Исключено баз: <b>{excludeDbIds.length}</b></>
//           )}
//           {excludeAlreadySent && (
//             <>{(excludeDbIds.length > 0) && " · "}Исключены получавшие</>
//           )}
//           {excludeReplied && (
//             <>{(excludeDbIds.length > 0 || excludeAlreadySent) && " · "}Исключены ответившие</>
//           )}
//         </div>
//       )}
//     </div>
//   )}
// </div>

//           {/* NORMAL CAMPAIGN */}
//           <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 space-y-3">
//             <h2 className="text-base md:text-lg font-semibold mb-1">Разовая классическая рассылка</h2>

//             <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 text-xs">
//               <div className="font-medium text-blue-900 mb-2">
//                 Используйте переменные для персонализации (клик — вставить в текст):
//               </div>
//               <div className="flex flex-wrap gap-1.5 mb-2">
//                 {['{{companyName}}', '{{name}}', '{{email}}', '{{city}}'].map((v) => (
//                   <code
//                     key={v}
//                     onClick={() => insertVariable(v)}
//                     title="Кликните, чтобы вставить в активное поле"
//                     className="bg-white px-2 py-0.5 rounded border border-blue-200 text-blue-800 font-mono text-[11px] cursor-pointer hover:bg-blue-100 hover:border-blue-400 active:scale-95 transition select-none"
//                   >
//                     {v}
//                   </code>
//                 ))}
//               </div>
//               <div className="text-blue-700 text-[11px] leading-relaxed">
//                 <b>Рандомизация:</b> разделяйте варианты через{' '}
//                 <code className="bg-white px-1 rounded border border-blue-200 font-mono">|</code>
//                 {' '}— будет выбран случайный
//               </div>
//             </div>

//             {/* ===== КНОПКА "ВСТАВИТЬ ИЗ ШАБЛОНА" ===== */}
//             {templates.length > 0 && (
//               <button
//                 type="button"
//                 onClick={() => setShowTemplatesModal(true)}
//                 className="w-full md:w-auto px-4 py-2 rounded-xl bg-purple-600 text-white hover:bg-purple-700 transition shadow-md text-sm inline-flex items-center justify-center gap-2"
//               >
//                 <FileText size={16} /> Вставить из шаблона ({templates.length})
//               </button>
//             )}

//             <input
//               placeholder="Название кампании: - Рассылка по юристам 24.09"
//               value={campaignName}
//               onChange={(e) => setCampaignName(e.target.value)}
//               className="w-full border rounded-xl px-3 py-2 text-sm"
//             />
//             <input
//               placeholder="Тема письма: - По поводу разработки ПО для {{name}}"
//               value={campaignSubject}
//               onChange={(e) => setCampaignSubject(e.target.value)}
//               className="w-full border rounded-xl px-3 py-2 text-sm"
//             />

//             <textarea
//               ref={campaignTextRef}
//               placeholder="Текст письма: Добрый день, {{name}} | Здравствуйте, {{name}}, ваша компания называется {{companyName}}?"
//               value={campaignTexts.join("|")}
//               onChange={(e) => setCampaignTexts(e.target.value.split("|"))}
//               className="w-full border rounded-xl px-3 py-2 text-sm"
//               rows={5}
//             />

//             <button
//               onClick={handleCreateCampaign}
//               className="w-full md:w-auto px-4 py-2 rounded-xl bg-green-600 text-white hover:bg-green-700 transition shadow-md text-sm inline-flex items-center justify-center gap-2"
//             >
//               <Send size={16} /> Запустить рассылку
//             </button>
//           </div>

// {/* SEQUENCE CAMPAIGN */}
// <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 space-y-2">
//   <h2 className="text-base md:text-lg font-semibold mb-1 flex items-center justify-between gap-2">
//     <span>Цепочка из 3-х писем (для профессионалов)</span>
//     {!isGold && (
//       <span className="text-[10px] px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-800 font-medium">
//         🔒 Gold
//       </span>
//     )}
//   </h2>

//   {isGold ? (
//     <>
//       <input
//         placeholder="Название кампании"
//         value={sequenceName}
//         onChange={(e) => setSequenceName(e.target.value)}
//         className="w-full border rounded-xl px-3 py-2 text-sm"
//       />
//       {sequence.map((step, i) => (
//         <div key={i} className="mb-3">
//           {i !== 0 && (
//             <div className="flex gap-2 items-center flex-wrap text-xs bg-yellow-50 border border-yellow-200 rounded-lg px-2 py-1.5 mb-1.5">
//               <span className="font-medium text-yellow-800 inline-flex items-center gap-1">
//                 <Clock size={12} /> Пауза перед письмом {i + 1}:
//               </span>
//               <input
//                 type="number"
//                 placeholder="Мин"
//                 value={step.delayMinutes || 0}
//                 onChange={(e) => updateSequence(i, "delayMinutes", Number(e.target.value))}
//                 className="border rounded-lg px-2 py-1 w-16 text-sm"
//               />
//               <span>мин</span>
//               <input
//                 type="number"
//                 placeholder="Сек"
//                 value={step.delaySeconds || 0}
//                 onChange={(e) => updateSequence(i, "delaySeconds", Number(e.target.value))}
//                 className="border rounded-lg px-2 py-1 w-16 text-sm"
//               />
//               <span>сек</span>
//               <span className="text-[10px] text-yellow-700 ml-auto">1 день = 1440 мин</span>
//             </div>
//           )}

//           <div className="border rounded-xl p-2">
//             <div className="font-semibold mb-1 text-sm">Письмо {i + 1}</div>
//             <input
//               placeholder="Тема письма"
//               value={step.subject}
//               onChange={(e) => updateSequence(i, "subject", e.target.value)}
//               className="w-full border rounded-xl px-2 py-1 mb-1 text-sm"
//             />
//             <textarea
//               ref={(el) => (sequenceRefs.current[i] = el)}
//               placeholder="Текст"
//               value={step.text}
//               onChange={(e) => updateSequence(i, "text", e.target.value)}
//               className="w-full border rounded-xl px-2 py-1 mb-1 text-sm"
//               rows={3}
//             />
//           </div>
//         </div>
//       ))}
//       <button
//         onClick={handleCreateSequenceCampaign}
//         className="w-full md:w-auto px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition shadow-md text-sm inline-flex items-center justify-center gap-2"
//       >
//         <Send size={16} /> Запустить цепочку
//       </button>
//     </>
//   ) : (
//     <div className="text-center py-6 px-3 bg-yellow-50 border border-yellow-200 rounded-xl">
//       <div className="text-3xl mb-2">🔒</div>
//       <div className="text-sm font-semibold text-gray-800 mb-1">
//         Доступно на тарифе Gold
//       </div>
//       <div className="text-xs text-gray-500 mb-4">
//         Цепочки из 3-х писем — только для Gold. Апгрейд тарифа откроет функцию.
//       </div>
//       <a
//         href="/pricing"
//         className="inline-block px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition shadow-md text-sm font-medium"
//       >
//         Перейти к тарифам →
//       </a>
//     </div>
//   )}
// </div>
//         </div>
//       </div>

//       {/* ===== МОДАЛКА: выбор шаблона ===== */}
//       {showTemplatesModal && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-3">
// <div className="bg-white rounded-2xl p-4 md:p-6 max-w-lg w-full shadow-xl max-h-[32vh] overflow-y-auto">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold flex items-center gap-2">
//                 <FileText size={18} className="text-purple-600" /> Выбрать шаблон
//               </h3>
//               <button
//                 onClick={() => setShowTemplatesModal(false)}
//                 className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
//                 title="Закрыть"
//               >×</button>
//             </div>

//             {templates.length === 0 ? (
//               <div className="text-center text-gray-500 py-8 text-sm">
//                 Нет шаблонов. Создайте во вкладке «Шаблоны».
//               </div>
//             ) : (
//               <div className="space-y-2">
//                 {templates.map(t => (
//                   <button
//                     key={t.id}
//                     onClick={() => applyTemplate(t)}
//                     className="w-full text-left p-3 rounded-xl border-2 border-gray-200 hover:border-purple-400 hover:bg-purple-50 transition"
//                   >
//                     <div className="font-medium text-sm text-gray-800 truncate">
//                       {t.name}
//                     </div>
//                     <div className="text-xs text-gray-500 mt-0.5 truncate">
//                       {t.subject || "(без темы)"}
//                     </div>
//                     <div className="text-xs text-gray-400 mt-1 line-clamp-2 whitespace-pre-wrap">
//                       {t.body || "(пусто)"}
//                     </div>
//                   </button>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       <style jsx>{`
//         @keyframes fade-in {
//           from { opacity: 0; transform: translate(-50%, -20px); }
//           to { opacity: 1; transform: translate(-50%, 0); }
//         }
//         .animate-fade-in { animation: fade-in 0.3s ease-out; }
//       `}</style>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import { getSmtpAccounts } from "../api/api";
import { getDatabasesWithCount } from "../api/databasesApi";
import { useLoading } from "./useLoading";
import { useAuth } from "./AuthContext";
import axios from "axios";
import {
  Mail, MailOpen, MessageSquare, Target, MousePointerClick,
  Send, Play, Pause, Square, CheckCircle2, Clock,
  ChevronRight, Copy, FileText,
} from "lucide-react";

export default function Campaigns() {
  const [smtpAccounts, setSmtpAccounts] = useState([]);
  const [selectedSmtpIds, setSelectedSmtpIds] = useState([]);
  const [databases, setDatabases] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaignId, setSelectedCampaignId] = useState(null);
  const [campaignDetails, setCampaignDetails] = useState(null);
  const [progress, setProgress] = useState(0);
  const [sentEmails, setSentEmails] = useState([]);
  const [emailFilter, setEmailFilter] = useState("all");
  const [selectedDbId, setSelectedDbId] = useState(null);
  const [excludeDbIds, setExcludeDbIds] = useState([]);
  const [excludeAlreadySent, setExcludeAlreadySent] = useState(false);
  const [excludeReplied, setExcludeReplied] = useState(false);
  const [copiedText, setCopiedText] = useState(null);
  const [nextSendTimer, setNextSendTimer] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);

  const [campaignName, setCampaignName] = useState("");
  const [campaignSubject, setCampaignSubject] = useState("");
  const [campaignTexts, setCampaignTexts] = useState([]);

  const [campaignStats, setCampaignStats] = useState(null);
  const [opensList, setOpensList] = useState([]);

  const { user } = useAuth();
  const isGold = user?.plan === "gold";

  // ===== ШАБЛОНЫ =====
  const [templates, setTemplates] = useState([]);
  const [showTemplatesModal, setShowTemplatesModal] = useState(false);

  // ===== МОДЕРАЦИЯ: редактирование отклонённых =====
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editForm, setEditForm] = useState({ id: null, name: "", subject: "", texts: [] });
  const [savingId, setSavingId] = useState(null);

  const [sequenceName, setSequenceName] = useState("");
  const [sequence, setSequence] = useState([
    { subject: "", text: "", delayMinutes: 0, delaySeconds: 0 },
    { subject: "", text: "", delayMinutes: 0, delaySeconds: 5 },
    { subject: "", text: "", delayMinutes: 0, delaySeconds: 5 },
  ]);

  const { loading, withLoading } = useLoading();
  const [selectAllSmtp, setSelectAllSmtp] = useState(false);

  const campaignTextRef = React.useRef(null);
  const sequenceRefs = React.useRef([]);

  const updateSequence = (index, field, value) => {
    const updated = [...sequence];
    updated[index][field] = value;
    setSequence(updated);
  };

  const copyToClipboard = (text) => {
    if (!text) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => {
          setCopiedText(text.slice(0, 50) + (text.length > 50 ? '...' : ''));
          setTimeout(() => setCopiedText(null), 2000);
        })
        .catch(() => fallbackCopy(text));
    } else {
      fallbackCopy(text);
    }
  };

  const fallbackCopy = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      setCopiedText(text.slice(0, 50) + (text.length > 50 ? '...' : ''));
      setTimeout(() => setCopiedText(null), 2000);
    } catch (err) {
      console.error('Ошибка копирования:', err);
    }
    document.body.removeChild(textarea);
  };

  const insertVariable = (variable) => {
    const active = document.activeElement;

    if (active && active.tagName === "TEXTAREA") {
      const start = active.selectionStart ?? active.value.length;
      const end = active.selectionEnd ?? active.value.length;
      const newValue = active.value.slice(0, start) + variable + active.value.slice(end);

      if (active === campaignTextRef.current) {
        setCampaignTexts(newValue.split("|"));
      } else {
        const idx = sequenceRefs.current.indexOf(active);
        if (idx !== -1) updateSequence(idx, "text", newValue);
      }

      requestAnimationFrame(() => {
        active.focus();
        const pos = start + variable.length;
        active.setSelectionRange(pos, pos);
      });
      return;
    }

    const textarea = campaignTextRef.current;
    if (textarea) {
      const current = textarea.value;
      const newValue = current + variable;
      setCampaignTexts(newValue.split("|"));
      requestAnimationFrame(() => {
        textarea.focus();
        textarea.setSelectionRange(newValue.length, newValue.length);
      });
    } else {
      setCampaignTexts((prev) => {
        const last = prev[prev.length - 1] || "";
        return [...prev.slice(0, -1), last + variable];
      });
    }
  };

  const calculateNextSendTime = (sentEmailsList, campaign) => {
    if (!campaign || !sentEmailsList.length) return null;
    const lastSent = sentEmailsList
      .filter(e => e.status === 'sent')
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
    if (!lastSent) return null;
    const sentCount = sentEmailsList.filter(e => e.status === 'sent').length;
    const defaultDelays = [0, 5, 10];
    const delayIndex = Math.min(sentCount, defaultDelays.length - 1);
    const delayMinutes = defaultDelays[delayIndex] || 5;
    const nextSendTime = new Date(lastSent.created_at);
    nextSendTime.setMinutes(nextSendTime.getMinutes() + delayMinutes);
    return nextSendTime;
  };

  useEffect(() => {
    async function load() {
      try {
        const smtpRes = await withLoading(() => getSmtpAccounts());
        setSmtpAccounts(smtpRes.data);
        const dbRes = await withLoading(() => getDatabasesWithCount());
        setDatabases(dbRes.data);
        const campaignsRes = await withLoading(() => axios.get("/api/campaigns"));
        setCampaigns(campaignsRes.data);

        // ===== ЗАГРУЗКА ШАБЛОНОВ =====
        try {
          const tplRes = await axios.get("/api/templates");
          setTemplates(tplRes.data || []);
        } catch (tplErr) {
          console.error("Ошибка загрузки шаблонов:", tplErr);
        }
      } catch (err) {
        console.error(err);
      }
    }
    load();
  }, []);

  useEffect(() => {
    if (!selectedCampaignId) {
      setCampaignStats(null);
      setOpensList([]);
      return;
    }
    (async () => {
      try {
        const [statsRes, opensRes] = await Promise.all([
          axios.get(`/api/campaigns/${selectedCampaignId}/stats`),
          axios.get(`/api/campaigns/${selectedCampaignId}/opens`),
        ]);
        setCampaignStats(statsRes.data);
        setOpensList(opensRes.data);
      } catch (err) {
        console.error("Ошибка загрузки статистики:", err);
      }
    })();
  }, [selectedCampaignId, sentEmails.length]);

  useEffect(() => {
    if (!selectedCampaignId) return;
    const interval = setInterval(async () => {
      try {
        const res = await axios.get(`/api/campaigns/${selectedCampaignId}`);
        const data = res.data;
        setCampaignDetails(data);
        setProgress(Math.round(((data.sent_count + data.failed_count) / data.total_count) * 100));
        const emailsRes = await axios.get(`/api/campaigns/${selectedCampaignId}/emails`);
        setSentEmails(emailsRes.data);
        const nextTime = calculateNextSendTime(emailsRes.data, data);
        setNextSendTimer(nextTime);
        setCampaigns((prev) =>
          prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: data.status } : c)
        );
        if (data.status === "completed" || data.status === "stopped") clearInterval(interval);
      } catch (err) {
        console.error(err);
      }
    }, 2000);
    return () => clearInterval(interval);
  }, [selectedCampaignId]);

  useEffect(() => {
    if (!nextSendTimer) { setTimeLeft(null); return; }
    const updateTimer = () => {
      const now = new Date();
      const diff = Math.max(0, Math.floor((nextSendTimer - now) / 1000));
      if (diff <= 0) setTimeLeft(null);
      else setTimeLeft(`${Math.floor(diff / 60)}:${(diff % 60).toString().padStart(2, '0')}`);
    };
    updateTimer();
    const timerInterval = setInterval(updateTimer, 1000);
    return () => clearInterval(timerInterval);
  }, [nextSendTimer]);

  const toggleSmtpSelect = (id) => {
    setSelectedSmtpIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const toggleSelectAllSmtp = () => {
    if (selectAllSmtp) setSelectedSmtpIds([]);
    else setSelectedSmtpIds(smtpAccounts.map((s) => s.id));
    setSelectAllSmtp(!selectAllSmtp);
  };

  const handleCreateCampaign = async () => {
    if (!selectedDbId || !campaignName || !campaignSubject || !campaignTexts.length || !selectedSmtpIds.length) {
      alert("Заполните все поля: выберите почты для работы, базу и напишите письмо");
      return;
    }
try {
  const res = await withLoading(() =>
    axios.post("/api/campaigns", {
      databaseId: Number(selectedDbId),
      name: campaignName,
      subject: campaignSubject,
      texts: campaignTexts,
      smtpIds: selectedSmtpIds,
      excludeDatabaseIds: excludeDbIds.map(Number),
      excludeAlreadySent,
      excludeReplied,
    })
  );
  const newCampaign = res.data;

  // HARD-слово — 400 не прилетит, но подстрахуемся
  if (newCampaign.softWarning) {
    alert(
      `⚠️ Внимание!\n\n${newCampaign.softWarning}\n\n` +
      `Кампания отправлена на модерацию — администратор проверит текст перед отправкой.`
    );
  } else if (newCampaign.requiresModeration) {
    alert("⏳ Кампания отправлена на модерацию. Вы получите уведомление после одобрения.");
  }

  setCampaigns([newCampaign, ...campaigns]);
  setSelectedCampaignId(newCampaign.campaignId);
  setExcludeDbIds([]);
  setExcludeAlreadySent(false);
  setExcludeReplied(false);
} catch (err) {
  console.error(err.response?.data || err);
  const data = err.response?.data;

  // HARD-слово — показываем красиво
  if (data?.code === "HARD_STOP_WORD") {
    alert(
      `🚫 В тексте обнаружено запрещённое слово: «${data.hardWord}»\n\n` +
      `В Mailora такое не приветствуется. Пожалуйста, отредактируйте тему и текст письма и попробуйте снова.`
    );
    return;
  }

  // Прочие ошибки валидации
  alert(`Ошибка: ${data?.error || err.message}`);
}
  };

  // ===== ПРИМЕНИТЬ ШАБЛОН =====
  const applyTemplate = (tpl) => {
    if (!tpl) return;
    if (campaignSubject || campaignTexts.length > 0) {
      if (!window.confirm("Заменить текущую тему и текст шаблоном?")) return;
    }
    setCampaignSubject(tpl.subject || "");

    const bodyText = tpl.body || "";

    let variants;
    if (bodyText.includes("|")) {
      variants = bodyText.split("|").map(v => v.trim());
    } else if (bodyText.includes("\n\n---\n\n")) {
      variants = bodyText.split("\n\n---\n\n").map(v => v.trim());
    } else if (bodyText.includes("---")) {
      variants = bodyText.split(/\s*---\s*/).map(v => v.trim());
    } else {
      variants = [bodyText.trim()];
    }

    variants = variants.filter(v => v.length > 0);

    setCampaignTexts(variants.length ? variants : [""]);
    setShowTemplatesModal(false);
  };

  // ===== РЕДАКТИРОВАНИЕ ОТКЛОНЁННОЙ КАМПАНИИ =====
  const openEditModal = (campaign) => {
    setEditForm({
      id: campaign.id,
      name: campaign.name || "",
      subject: campaign.subject || "",
      texts: Array.isArray(campaign.texts) ? campaign.texts : [campaign.texts || ""],
    });
    setEditModalOpen(true);
  };

  const handleSaveEdit = async () => {
    if (!editForm.id) return;
    try {
      setSavingId(editForm.id);
      await axios.patch(`/api/campaigns/${editForm.id}`, {
        name: editForm.name,
        subject: editForm.subject,
        texts: editForm.texts,
      });
      setEditModalOpen(false);
      if (selectedCampaignId === editForm.id) {
        const res = await axios.get(`/api/campaigns/${editForm.id}`);
        setCampaignDetails(res.data);
      }
      const campaignsRes = await axios.get("/api/campaigns");
      setCampaigns(campaignsRes.data);
      alert("Изменения сохранены");
    } catch (err) {
      console.error(err);
      alert("Ошибка: " + (err.response?.data?.error || err.message));
    } finally {
      setSavingId(null);
    }
  };

  const handleResubmit = async () => {
    if (!selectedCampaignId) return;
    if (!window.confirm("Отправить кампанию на модерацию повторно?")) return;
    try {
      setSavingId(selectedCampaignId);
      await axios.post(`/api/campaigns/${selectedCampaignId}/resubmit`);
      const res = await axios.get(`/api/campaigns/${selectedCampaignId}`);
      setCampaignDetails(res.data);
      const campaignsRes = await axios.get("/api/campaigns");
      setCampaigns(campaignsRes.data);
      alert("Кампания отправлена на модерацию");
    } catch (err) {
      console.error(err);
      alert("Ошибка: " + (err.response?.data?.error || err.message));
    } finally {
      setSavingId(null);
    }
  };

  const handleCreateSequenceCampaign = async () => {
    if (!selectedDbId || !sequenceName.trim() || selectedSmtpIds.length === 0) {
      alert("Заполните базу, название и SMTP");
      return;
    }
    if (!sequence.every((s) => s.subject.trim() && s.text.trim())) {
      alert("Заполните subject и text для всех писем");
      return;
    }
    const defaultSubject = sequence[0]?.subject || "No Subject";
    try {
      const res = await withLoading(() =>
        axios.post("/api/campaigns/sequence", {
          databaseId: Number(selectedDbId),
          name: sequenceName,
          smtpIds: selectedSmtpIds,
          sequence,
          subject: defaultSubject,
        })
      );
      const newCampaign = res.data;
      const delays = sequence.slice(1).map(s =>
        s.delayMinutes > 0 ? `${s.delayMinutes}м` : `${s.delaySeconds}с`
      );
      const sequenceInfo = ` (${sequence.length} письма, паузы: ${delays.join(', ')})`;
      setCampaigns((prev) => [
        { campaignId: newCampaign.campaignId, name: sequenceName + sequenceInfo, status: "running", isSequence: true, sequenceInfo },
        ...prev,
      ]);
      setSelectedCampaignId(newCampaign.campaignId);
      setExcludeDbIds([]);
      setExcludeAlreadySent(false);
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "Ошибка запуска sequence");
    }
  };

  const handlePause = async () => {
    if (!selectedCampaignId) return;
    try {
      await withLoading(() => axios.post(`/api/campaigns/${selectedCampaignId}/pause`));
      setCampaignDetails((prev) => ({ ...prev, status: "paused" }));
      setCampaigns((prev) => prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: "paused" } : c));
    } catch (err) {
      alert(err.response?.data?.error || "Ошибка при постановке на паузу");
    }
  };

  const handleResume = async () => {
    if (!selectedCampaignId) return;
    try {
      await withLoading(() => axios.post(`/api/campaigns/${selectedCampaignId}/resume`));
      setCampaignDetails((prev) => ({ ...prev, status: "running" }));
      setCampaigns((prev) => prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: "running" } : c));
    } catch (err) {
      alert(err.response?.data?.error || "Ошибка при возобновлении");
    }
  };

  const handleStop = async () => {
    if (!selectedCampaignId) return;
    try {
      await withLoading(() => axios.post(`/api/campaigns/${selectedCampaignId}/stop`));
      setCampaignDetails((prev) => ({ ...prev, status: "stopped" }));
      setCampaigns((prev) => prev.map((c) => c.campaignId === selectedCampaignId ? { ...c, status: "stopped" } : c));
    } catch (err) {
      alert(err.response?.data?.error || "Ошибка при остановке");
    }
  };

  const displayedEmails = sentEmails.filter((e) => {
    if (emailFilter === "all") return true;
    if (emailFilter === "sent") return e.status === "sent";
    if (emailFilter === "failed") return e.status === "failed";
    return true;
  });

  const StatusBadge = ({ status }) => {
    if (status === "paused") return (
      <span className="inline-flex items-center gap-1 text-yellow-600">
        <Pause size={12} /> На паузе
      </span>
    );
    if (status === "running") return (
      <span className="inline-flex items-center gap-1 text-green-600">
        <Play size={12} /> Выполняется
      </span>
    );
    if (status === "completed") return (
      <span className="inline-flex items-center gap-1 text-green-600">
        <CheckCircle2 size={12} /> Завершена
      </span>
    );
    if (status === "stopped") return (
      <span className="inline-flex items-center gap-1 text-red-600">
        <Square size={12} /> Остановлена
      </span>
    );
    return <span className="text-gray-500">{status}</span>;
  };

  const findTracking = (email) => opensList.find(o => o.recipient_email === email);

  return (
    <div className="min-h-screen bg-gray-50 p-3 md:p-4">
      {loading && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="w-20 h-20 border-8 border-gray-200 border-t-8 border-t-blue-600 rounded-full animate-spin" />
        </div>
      )}

      {copiedText && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-4 py-2 rounded-xl shadow-lg z-50 text-sm inline-flex items-center gap-2">
          <CheckCircle2 size={14} /> Скопировано
        </div>
      )}

      <h1 className="text-xl md:text-2xl font-bold mb-4 flex items-center gap-2">
        <Send size={22} className="text-blue-600" /> Email кампании
      </h1>

      <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">

        {/* ===== ЛЕВАЯ ПАНЕЛЬ ===== */}
        <div className="w-full md:w-1/2 flex flex-col space-y-4">

          {/* SMTP */}
          <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
            <h2 className="text-base md:text-lg font-semibold mb-2 flex items-center gap-2">
              Выберите почты для рассылок
            </h2>

            <div className="hidden md:block overflow-auto border rounded-xl">
              <table className="w-full text-sm">
                <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider">
                  <tr>
                    <th className="px-2 py-1 text-left">
                      <input type="checkbox" checked={selectAllSmtp} onChange={toggleSelectAllSmtp} />
                    </th>
                    <th className="px-2 py-1 text-left">Email</th>
                    <th className="px-2 py-1 text-left">Сегодня</th>
                    <th className="px-2 py-1 text-left">Всего</th>
                  </tr>
                </thead>
                <tbody>
                  {smtpAccounts.map((s) => (
                    <tr key={s.id} className="border-t hover:bg-gray-50 transition">
                      <td className="px-2 py-1">
                        <input
                          type="checkbox"
                          checked={selectedSmtpIds.includes(s.id)}
                          onChange={() => toggleSmtpSelect(s.id)}
                        />
                      </td>
                      <td className="px-2 py-1 font-medium text-gray-800">{s.email}</td>
                      <td className="px-2 py-1 text-gray-600">{s.sentToday || 0}</td>
                      <td className="px-2 py-1 text-gray-600">{s.sentTotal || 0}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="md:hidden space-y-2">
              {smtpAccounts.length > 0 && (
                <div className="flex items-center gap-2 px-2 py-1.5 bg-gray-50 rounded-lg">
                  <input
                    type="checkbox"
                    checked={selectAllSmtp}
                    onChange={toggleSelectAllSmtp}
                    className="w-4 h-4"
                  />
                  <span className="text-xs text-gray-600">Выбрать все</span>
                </div>
              )}
              {smtpAccounts.length === 0 && (
                <div className="text-xs text-gray-400 text-center py-4">Нет SMTP</div>
              )}
              {smtpAccounts.map((s) => (
                <label
                  key={s.id}
                  className={`flex items-start gap-2 p-2 rounded-lg cursor-pointer transition ${
                    selectedSmtpIds.includes(s.id) ? 'bg-blue-50 ring-1 ring-blue-400' : 'bg-gray-50'
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={selectedSmtpIds.includes(s.id)}
                    onChange={() => toggleSmtpSelect(s.id)}
                    className="mt-0.5 w-4 h-4 flex-shrink-0"
                  />
                  <div className="flex-1 min-w-0">
                    <div className="text-xs font-medium text-gray-800 truncate">{s.email}</div>
                    <div className="flex gap-3 mt-0.5 text-[11px] text-gray-500">
                      <span>Сегодня: {s.sentToday || 0}</span>
                      <span>Всего: {s.sentTotal || 0}</span>
                    </div>
                  </div>
                </label>
              ))}
            </div>
          </div>

          {/* ===== CAMPAIGNS LIST ===== */}
          <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
            <h2 className="text-base md:text-lg font-semibold mb-2 flex items-center gap-2">
              Все кампании
            </h2>
            <div className="flex flex-col space-y-1.5 max-h-72 md:max-h-80 overflow-y-auto">
              {campaigns.length === 0 && (
                <div className="text-xs text-gray-400 text-center py-4">Нет кампаний</div>
              )}
              {campaigns.map((c) => {
                const dateStr = c.created_at
                  ? new Date(c.created_at).toLocaleString('ru-RU', {
                      day: '2-digit',
                      month: '2-digit',
                      hour: '2-digit',
                      minute: '2-digit',
                    })
                  : '—';

                const sent = c.sent ?? c.sent_count ?? 0;
                const opened = c.opened ?? 0;
                const replied = c.replied ?? 0;
                const leads = c.leads ?? 0;
                const total = c.total ?? c.total_count ?? 0;

                const isActive = c.campaignId === selectedCampaignId;

                return (
                  <button
                    key={c.campaignId}
                    onClick={() => setSelectedCampaignId(c.campaignId)}
                    className={`w-full text-left px-3 py-3 rounded-xl transition flex items-center gap-3 ${
                      isActive
                        ? "bg-blue-50 border-2 border-blue-500"
                        : "hover:bg-gray-50 border-2 border-transparent"
                    }`}
                  >
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="font-semibold text-sm text-gray-800 truncate">
                          #{c.campaignId} — {c.name}
                        </span>
                        <span className="text-xs flex-shrink-0">
                          <StatusBadge status={c.status} />
                        </span>
                        {c.moderation_status === "pending" && (
                          <span className="text-[10px] bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full font-medium">
                            ⏳ На модерации
                          </span>
                        )}
                        {c.moderation_status === "rejected" && (
                          <span className="text-[10px] bg-red-100 text-red-800 px-2 py-0.5 rounded-full font-medium">
                            ❌ Отклонена
                          </span>
                        )}
                        {c.status === "running" && (
                          <div className="w-3 h-3 border-2 border-blue-500 border-t-transparent rounded-full animate-spin flex-shrink-0" />
                        )}
                        {c.isSequence && c.status === "running" && timeLeft && (
                          <span className="bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded-full text-[10px] flex-shrink-0 inline-flex items-center gap-1">
                            <Clock size={10} /> {timeLeft}
                          </span>
                        )}
                      </div>

                      <div className="text-xs text-gray-500 mt-1 flex items-center flex-wrap gap-x-2 gap-y-0.5">
                        <span className="inline-flex items-center gap-1">
                          <Send size={11} className="text-gray-400" />
                          <b className="text-gray-400">{sent}</b>
                          {total > 0 && (
                            <span className="text-gray-400">
                              из <b>{total}</b>
                            </span>
                          )}
                        </span>
                        <span className="text-gray-300">·</span>
                        <span className="inline-flex items-center gap-1">
                          <MailOpen size={11} className="text-gray-400" />
                          <b className="text-gray-400">{opened} открыли</b>
                        </span>
                        <span className="text-gray-300">·</span>
                        <span className="inline-flex items-center gap-1">
                          <MessageSquare size={11} className="text-gray-400" />
                          <b className="text-gray-400">{replied} ответили</b>
                        </span>
                        <span className="text-gray-300">·</span>
                        <span className="inline-flex items-center gap-1">
                          <Target size={11} className="text-purple-500" />
                          <b className="text-purple-600">{leads} лидов</b>
                        </span>
                        <span className="text-gray-300">·</span>
                        <span className="text-gray-400">{dateStr}</span>
                      </div>
                    </div>

                    <ChevronRight
                      size={18}
                      className={`flex-shrink-0 transition ${
                        isActive ? "text-blue-500" : "text-gray-300"
                      }`}
                    />
                  </button>
                );
              })}
            </div>
          </div>

          {/* ===== CAMPAIGN DETAILS ===== */}
          {campaignDetails && (
            <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 space-y-2">
              <h2 className="text-base md:text-lg font-semibold mb-2">
                Детали #{selectedCampaignId}
              </h2>

              {campaignDetails.moderation_status === "rejected" && (
                <div className="bg-red-50 border border-red-200 rounded-xl p-3 mb-2">
                  <div className="text-sm font-semibold text-red-800 mb-2 flex items-center gap-2">
                    ❌ Кампания отклонена модератором
                  </div>
                  {campaignDetails.moderation_comment && (
                    <div className="text-xs text-red-700 bg-white rounded-lg p-2 mb-3 border border-red-100">
                      <b>Комментарий:</b> {campaignDetails.moderation_comment}
                    </div>
                  )}
                  <div className="flex flex-wrap gap-2">
                    <button
                      onClick={() => openEditModal(campaignDetails)}
                      className="px-3 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition text-sm font-medium"
                    >
                      ✏️ Редактировать
                    </button>
                    <button
                      onClick={handleResubmit}
                      disabled={savingId === campaignDetails.id}
                      className="px-3 py-2 rounded-xl bg-green-600 text-white hover:bg-green-700 transition text-sm font-medium disabled:opacity-50"
                    >
                      🔄 Отправить на модерацию повторно
                    </button>
                  </div>
                </div>
              )}

              {campaignDetails.moderation_status === "pending" && (
                <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-3 mb-2">
                  <div className="text-sm font-semibold text-yellow-800 flex items-center gap-2">
                    ⏳ Кампания на модерации
                  </div>
                  <div className="text-xs text-yellow-700 mt-1">
                    Администратор проверит текст письма. Пока кампания не одобрена — рассылка не начнётся.
                  </div>
                </div>
              )}

              <div className="text-xs md:text-sm text-gray-600 flex items-center gap-2 flex-wrap">
                <span className="font-semibold">Статус:</span>
                <span className="capitalize"><StatusBadge status={campaignDetails.status} /></span>
                {campaignDetails.status === "running" && (
                  <div className="w-3 h-3 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
                )}
              </div>

              <div className="w-full bg-gray-200 h-2 rounded-full mb-2 overflow-hidden">
                <div
                  className={`h-2 transition-all duration-500 ${
                    campaignDetails.status === "paused" ? "bg-yellow-500" :
                    campaignDetails.status === "completed" ? "bg-blue-500" :
                    campaignDetails.status === "stopped" ? "bg-red-500" :
                    "bg-green-600"
                  }`}
                  style={{ width: `${progress}%` }}
                />
              </div>

              <div className="text-xs md:text-sm text-gray-600">
                {campaignDetails.sent_count} отправлено / {campaignDetails.failed_count} ошибок / {campaignDetails.total_count} всего
              </div>

              {campaignStats && campaignStats.sent > 0 && (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-3">
                  <div className="bg-blue-50 border border-blue-200 rounded-xl p-2.5">
                    <div className="text-[10px] md:text-xs text-blue-700 font-medium flex items-center gap-1">
                      <MailOpen size={12} /> Открыто
                    </div>
                    <div className="text-lg md:text-xl font-bold text-blue-800">
                      {campaignStats.opened}
                      <span className="text-xs font-normal text-blue-600 ml-1">
                        ({campaignStats.openRate}%)
                      </span>
                    </div>
                    <div className="text-[10px] text-blue-500 mt-0.5">
                      всего открытий: {campaignStats.totalOpens}
                    </div>
                  </div>

                  <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-2.5">
                    <div className="text-[10px] md:text-xs text-emerald-700 font-medium flex items-center gap-1">
                      <MousePointerClick size={12} /> Кликов
                    </div>
                    <div className="text-lg md:text-xl font-bold text-emerald-800">
                      {campaignStats.clicked}
                      <span className="text-xs font-normal text-emerald-600 ml-1">
                        ({campaignStats.clickRate}%)
                      </span>
                    </div>
                    <div className="text-[10px] text-emerald-500 mt-0.5">
                      всего кликов: {campaignStats.totalClicks}
                    </div>
                  </div>

                  <div className="bg-teal-50 border border-teal-200 rounded-xl p-2.5">
                    <div className="text-[10px] md:text-xs text-teal-700 font-medium flex items-center gap-1">
                      <MessageSquare size={12} /> Ответили
                    </div>
                    <div className="text-lg md:text-xl font-bold text-teal-800">
                      {campaignStats.replied}
                      <span className="text-xs font-normal text-teal-600 ml-1">
                        ({campaignStats.replyRate}%)
                      </span>
                    </div>
                    <div className="text-[10px] text-teal-500 mt-0.5">уникальных</div>
                  </div>

                  <div className="bg-purple-50 border border-purple-200 rounded-xl p-2.5">
                    <div className="text-[10px] md:text-xs text-purple-700 font-medium flex items-center gap-1">
                      <Target size={12} /> Лидов
                    </div>
                    <div className="text-lg md:text-xl font-bold text-purple-800">
                      {campaignStats.leads}
                      <span className="text-xs font-normal text-purple-600 ml-1">
                        ({campaignStats.leadRate}%)
                      </span>
                    </div>
                    <div className="text-[10px] text-purple-500 mt-0.5">из ответивших</div>
                  </div>
                </div>
              )}

              {campaignStats && campaignStats.sent > 0 && (
                <div className="bg-gradient-to-br from-blue-50 to-purple-50 border border-blue-200 rounded-xl p-3 md:p-4 mt-3">
                  <div className="text-sm font-semibold text-gray-800 mb-3 flex items-center gap-2">
                    Воронка кампании
                  </div>

                  <div className="space-y-2.5">
                    <div>
                      <div className="flex justify-between text-xs md:text-sm mb-1">
                        <span className="text-gray-600 font-medium flex items-center gap-1.5">
                          <Send size={13} /> Отправлено
                        </span>
                        <span className="font-bold text-gray-800">
                          {campaignStats.sent}
                          <span className="text-gray-400 font-normal ml-1">100%</span>
                        </span>
                      </div>
                      <div className="w-full bg-white rounded-full h-2 overflow-hidden">
                        <div className="h-full bg-gray-400" style={{ width: "100%" }} />
                      </div>
                    </div>

                    <div>
                      <div className="flex justify-between text-xs md:text-sm mb-1">
                        <span className="text-gray-600 font-medium flex items-center gap-1.5">
                          <MailOpen size={13} /> Открыто
                        </span>
                        <span className="font-bold text-cyan-700">
                          {campaignStats.opened}
                          <span className="text-gray-400 font-normal ml-1">
                            {campaignStats.openFromSent}%
                          </span>
                        </span>
                      </div>
                      <div className="w-full bg-white rounded-full h-2 overflow-hidden">
                        <div
                          className="h-full bg-cyan-500 transition-all duration-500"
                          style={{ width: `${campaignStats.openFromSent}%` }}
                        />
                      </div>
                    </div>

                    <div>
                      <div className="flex justify-between text-xs md:text-sm mb-1">
                        <span className="text-gray-600 font-medium flex items-center gap-1.5">
                          <MessageSquare size={13} /> Ответили
                        </span>
                        <span className="font-bold text-teal-700">
                          {campaignStats.replied}
                          <span className="text-gray-400 font-normal ml-1">
                            {campaignStats.replyFromOpened}% от открытых
                          </span>
                        </span>
                      </div>
                      <div className="w-full bg-white rounded-full h-2 overflow-hidden">
                        <div
                          className="h-full bg-teal-500 transition-all duration-500"
                          style={{ width: `${campaignStats.replyFromOpened}%` }}
                        />
                      </div>
                    </div>

                    <div>
                      <div className="flex justify-between text-xs md:text-sm mb-1">
                        <span className="text-gray-600 font-medium flex items-center gap-1.5">
                          <Target size={13} /> Стали лидами
                        </span>
                        <span className="font-bold text-purple-700">
                          {campaignStats.leads}
                          <span className="text-gray-400 font-normal ml-1">
                            {campaignStats.leadFromReplied}% от ответивших
                          </span>
                        </span>
                      </div>
                      <div className="w-full bg-white rounded-full h-2 overflow-hidden">
                        <div
                          className="h-full bg-purple-500 transition-all duration-500"
                          style={{ width: `${campaignStats.leadFromReplied}%` }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mt-3 pt-3 border-t border-blue-200 flex items-center justify-between">
                    <span className="text-xs text-gray-500">Итоговая конверсия в лида</span>
                    <span className="text-2xl font-bold text-purple-700">
                      {campaignStats.leadRate}%
                    </span>
                  </div>
                </div>
              )}

              <div className="flex flex-wrap gap-2 mt-2">
                {campaignDetails.status === "running" && (
                  <>
                    <button
                      onClick={handlePause}
                      className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-yellow-500 text-white hover:bg-yellow-600 transition text-sm inline-flex items-center justify-center gap-1.5"
                    >
                      <Pause size={14} /> Пауза
                    </button>
                    <button
                      onClick={handleStop}
                      className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-red-500 text-white hover:bg-red-600 transition text-sm inline-flex items-center justify-center gap-1.5"
                    >
                      <Square size={14} /> Остановить
                    </button>
                  </>
                )}
                {campaignDetails.status === "paused" && (
                  <>
                    <button
                      onClick={handleResume}
                      className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-green-500 text-white hover:bg-green-600 transition text-sm inline-flex items-center justify-center gap-1.5"
                    >
                      <Play size={14} /> Возобновить
                    </button>
                    <button
                      onClick={handleStop}
                      className="flex-1 md:flex-none px-3 py-2 rounded-xl bg-red-500 text-white hover:bg-red-600 transition text-sm inline-flex items-center justify-center gap-1.5"
                    >
                      <Square size={14} /> Остановить
                    </button>
                  </>
                )}
                {(campaignDetails.status === "stopped" || campaignDetails.status === "completed") && (
                  <span className="text-xs md:text-sm text-gray-500 inline-flex items-center gap-1.5">
                    {campaignDetails.status === "completed"
                      ? <><CheckCircle2 size={14} className="text-green-600" /> Завершена</>
                      : <><Square size={14} className="text-red-600" /> Остановлена</>
                    }
                  </span>
                )}
              </div>

              {/* Desktop: emails table */}
              <div className="hidden md:block overflow-x-auto rounded-xl border border-gray-200 max-h-60 overflow-y-auto mt-2">
                <table className="w-full text-sm">
                  <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider sticky top-0 z-10">
                    <tr>
                      <th className="px-2 py-1 text-left">ПОЛУЧАТЕЛЬ</th>
                      <th className="px-2 py-1 text-left">СТАТУС</th>
                      <th className="px-2 py-1 text-left">SMTP ПОЧТА</th>
                      <th className="px-2 py-1 text-left">ОТПРАВЛЕНО</th>
                      <th className="px-2 py-1 text-left">ОТКРЫТО</th>
                      <th className="px-2 py-1 text-left">ТЕМА</th>
                      <th className="px-2 py-1 text-left">ТЕКСТ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedEmails.map((e) => {
                      const t = findTracking(e.recipient_email);
                      return (
                        <tr key={e.id} className="border-t hover:bg-gray-50 transition">
                          <td className="px-2 py-1">{e.recipient_email}</td>
                          <td className="px-2 py-1 capitalize">{e.status}</td>
                          <td className="px-2 py-1">{e.smtp_email}</td>
                          <td className="px-2 py-1">{new Date(e.created_at).toLocaleString()}</td>
                          <td className="px-2 py-1">
                            {!t ? (
                              <span className="text-gray-300">—</span>
                            ) : t.opened_at ? (
                              <span className="inline-flex items-center gap-1 text-emerald-600 text-xs">
                                <MailOpen size={12} /> {t.open_count}
                                {t.clicked_at && (
                                  <span className="text-blue-600 inline-flex items-center gap-0.5 ml-1">
                                    · <MousePointerClick size={11} />{t.click_count}
                                  </span>
                                )}
                              </span>
                            ) : (
                              <span className="text-gray-400 text-xs inline-flex items-center gap-1">
                                <Clock size={11} />
                              </span>
                            )}
                          </td>
                          <td
                            className="px-2 py-1 min-w-[200px] max-w-[300px] break-words cursor-pointer hover:text-blue-600 transition"
                            onClick={() => copyToClipboard(e.subject || campaignSubject)}
                            title="Кликни чтобы скопировать тему"
                          >
                            {e.subject || campaignSubject}
                          </td>
                          <td
                            className="px-2 py-1 min-w-[200px] max-w-[300px] break-words cursor-pointer hover:text-blue-600 transition"
                            onClick={() => {
                              const text = Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ");
                              copyToClipboard(text);
                            }}
                            title="Кликни чтобы скопировать текст"
                          >
                            {Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ")}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Mobile: emails cards */}
              <div className="md:hidden space-y-2 mt-2 max-h-80 overflow-y-auto">
                {displayedEmails.length === 0 && (
                  <div className="text-xs text-gray-400 text-center py-4">Нет писем</div>
                )}
                {displayedEmails.map((e) => {
                  const t = findTracking(e.recipient_email);
                  return (
                    <div key={e.id} className="bg-gray-50 rounded-xl p-2 text-xs">
                      <div className="flex justify-between items-start gap-2 mb-1">
                        <div className="font-medium text-gray-800 truncate flex-1">{e.recipient_email}</div>
                        <span className={`px-1.5 py-0.5 rounded-full text-[10px] whitespace-nowrap ${
                          e.status === "sent" ? "bg-green-100 text-green-700" :
                          e.status === "failed" ? "bg-red-100 text-red-700" :
                          "bg-gray-100 text-gray-700"
                        }`}>
                          {e.status}
                        </span>
                      </div>
                      <div className="text-gray-500 mb-1 truncate">SMTP: {e.smtp_email}</div>
                      <div className="text-gray-400 mb-1.5">{new Date(e.created_at).toLocaleString('ru-RU')}</div>

                      {t && (
                        <div className="flex gap-2 text-[11px] mb-1.5">
                          {t.opened_at ? (
                            <span className="text-emerald-600 inline-flex items-center gap-1">
                              <MailOpen size={11} /> Открыто {t.open_count}×
                            </span>
                          ) : (
                            <span className="text-gray-400 inline-flex items-center gap-1">
                              <Clock size={11} /> Не открыто
                            </span>
                          )}
                          {t.clicked_at && (
                            <span className="text-blue-600 inline-flex items-center gap-1">
                              <MousePointerClick size={11} /> {t.click_count}×
                            </span>
                          )}
                        </div>
                      )}

                      <div
                        className="text-blue-600 cursor-pointer truncate mb-0.5 inline-flex items-center gap-1 w-full"
                        onClick={() => copyToClipboard(e.subject || campaignSubject)}
                      >
                        <Mail size={11} className="flex-shrink-0" />
                        <span className="truncate">{e.subject || campaignSubject}</span>
                      </div>
                      <div
                        className="text-gray-600 cursor-pointer line-clamp-2"
                        onClick={() => {
                          const text = Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ");
                          copyToClipboard(text);
                        }}
                      >
                        {Array.isArray(e.texts) ? e.texts.join(" | ") : e.texts || campaignTexts.join(" | ")}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        {/* ===== ПРАВАЯ ПАНЕЛЬ ===== */}
        <div className="w-full md:w-2/3 flex flex-col space-y-4">

          {/* DATABASE SELECT */}
          <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
            <h2 className="text-base md:text-lg font-semibold mb-2">База контактов</h2>
            <select
              value={selectedDbId || ""}
              onChange={(e) => {
                setSelectedDbId(e.target.value);
                setExcludeDbIds((prev) => prev.filter((id) => id !== Number(e.target.value)));
              }}
              className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
            >
              <option value="">Выберите базу</option>
              {databases.map((db) => (
                <option key={db.id} value={db.id}>
                  {db.name} ({db.contacts_count})
                </option>
              ))}
            </select>

            {selectedDbId && databases.length > 1 && (
              <div className="mt-3 border-t pt-3">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-sm font-semibold text-gray-700">
                    Исключить контакты из баз:
                  </h3>
                  {excludeDbIds.length > 0 && (
                    <button
                      onClick={() => setExcludeDbIds([])}
                      className="text-xs text-blue-600 hover:text-blue-800 underline"
                    >
                      сбросить
                    </button>
                  )}
                </div>

                <div className="border rounded-xl p-2 max-h-40 overflow-y-auto bg-gray-50">
                  {databases
                    .filter((db) => db.id !== Number(selectedDbId))
                    .map((db) => (
                      <label
                        key={db.id}
                        className="flex items-center gap-2 p-1.5 hover:bg-white rounded cursor-pointer transition"
                      >
                        <input
                          type="checkbox"
                          checked={excludeDbIds.includes(db.id)}
                          onChange={() => {
                            setExcludeDbIds((prev) =>
                              prev.includes(db.id)
                                ? prev.filter((id) => id !== db.id)
                                : [...prev, db.id]
                            );
                          }}
                          className="w-4 h-4 flex-shrink-0"
                        />
                        <span className="text-xs text-gray-700 flex-1 truncate">
                          {db.name}
                        </span>
                        <span className="text-[10px] text-gray-400 flex-shrink-0">
                          {db.contacts_count} конт.
                        </span>
                      </label>
                    ))}
                </div>

                <label className="flex items-start gap-2 mt-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={excludeAlreadySent}
                    onChange={(e) => setExcludeAlreadySent(e.target.checked)}
                    className="w-4 h-4 mt-0.5 flex-shrink-0"
                  />
                  <span className="text-xs text-gray-700">
                    <b>Не отправлять тем, кто уже получал письма</b>
                    <span className="block text-[10px] text-gray-400 mt-0.5">
                      Проверяет все прошлые кампании — исключает тех, кому уже ушло письмо
                    </span>
                  </span>
                </label>

                <label className="flex items-start gap-2 mt-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={excludeReplied}
                    onChange={(e) => setExcludeReplied(e.target.checked)}
                    className="w-4 h-4 mt-0.5 flex-shrink-0"
                  />
                  <span className="text-xs text-gray-700">
                    <b>Не отправлять тем, кто уже отвечал</b>
                    <span className="block text-[10px] text-gray-400 mt-0.5">
                      Исключает тех, от кого приходил хоть один ответ в любой переписке
                    </span>
                  </span>
                </label>

                {(excludeDbIds.length > 0 || excludeAlreadySent || excludeReplied) && (
                  <div className="mt-3 p-2 bg-blue-50 border border-blue-200 rounded-lg text-xs text-blue-800">
                    {excludeDbIds.length > 0 && (
                      <>Исключено баз: <b>{excludeDbIds.length}</b></>
                    )}
                    {excludeAlreadySent && (
                      <>{(excludeDbIds.length > 0) && " · "}Исключены получавшие</>
                    )}
                    {excludeReplied && (
                      <>{(excludeDbIds.length > 0 || excludeAlreadySent) && " · "}Исключены ответившие</>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* NORMAL CAMPAIGN */}
          <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 space-y-3">
            <h2 className="text-base md:text-lg font-semibold mb-1">Разовая классическая рассылка</h2>

            <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 text-xs">
              <div className="font-medium text-blue-900 mb-2">
                Используйте переменные для персонализации (клик — вставить в текст):
              </div>
              <div className="flex flex-wrap gap-1.5 mb-2">
                {['{{companyName}}', '{{name}}', '{{email}}', '{{city}}'].map((v) => (
                  <code
                    key={v}
                    onClick={() => insertVariable(v)}
                    title="Кликните, чтобы вставить в активное поле"
                    className="bg-white px-2 py-0.5 rounded border border-blue-200 text-blue-800 font-mono text-[11px] cursor-pointer hover:bg-blue-100 hover:border-blue-400 active:scale-95 transition select-none"
                  >
                    {v}
                  </code>
                ))}
              </div>
              <div className="text-blue-700 text-[11px] leading-relaxed">
                <b>Рандомизация:</b> разделяйте варианты через{' '}
                <code className="bg-white px-1 rounded border border-blue-200 font-mono">|</code>
                {' '}— будет выбран случайный
              </div>
            </div>

            {templates.length > 0 && (
              <button
                type="button"
                onClick={() => setShowTemplatesModal(true)}
                className="w-full md:w-auto px-4 py-2 rounded-xl bg-purple-600 text-white hover:bg-purple-700 transition shadow-md text-sm inline-flex items-center justify-center gap-2"
              >
                <FileText size={16} /> Вставить из шаблона ({templates.length})
              </button>
            )}

            <input
              placeholder="Название кампании: - Рассылка по юристам 24.09"
              value={campaignName}
              onChange={(e) => setCampaignName(e.target.value)}
              className="w-full border rounded-xl px-3 py-2 text-sm"
            />
            <input
              placeholder="Тема письма: - По поводу разработки ПО для {{name}}"
              value={campaignSubject}
              onChange={(e) => setCampaignSubject(e.target.value)}
              className="w-full border rounded-xl px-3 py-2 text-sm"
            />

            <textarea
              ref={campaignTextRef}
              placeholder="Текст письма: Добрый день, {{name}} | Здравствуйте, {{name}}, ваша компания называется {{companyName}}?"
              value={campaignTexts.join("|")}
              onChange={(e) => setCampaignTexts(e.target.value.split("|"))}
              className="w-full border rounded-xl px-3 py-2 text-sm"
              rows={5}
            />

            <button
              onClick={handleCreateCampaign}
              className="w-full md:w-auto px-4 py-2 rounded-xl bg-green-600 text-white hover:bg-green-700 transition shadow-md text-sm inline-flex items-center justify-center gap-2"
            >
              <Send size={16} /> Запустить рассылку
            </button>
          </div>

          {/* SEQUENCE CAMPAIGN */}
          <div className="bg-white rounded-2xl shadow-md p-3 md:p-4 space-y-2">
            <h2 className="text-base md:text-lg font-semibold mb-1 flex items-center justify-between gap-2">
              <span>Цепочка из 3-х писем (для профессионалов)</span>
              {!isGold && (
                <span className="text-[10px] px-2 py-0.5 rounded-full bg-yellow-100 text-yellow-800 font-medium">
                  🔒 Gold
                </span>
              )}
            </h2>

            {isGold ? (
              <>
                <input
                  placeholder="Название кампании"
                  value={sequenceName}
                  onChange={(e) => setSequenceName(e.target.value)}
                  className="w-full border rounded-xl px-3 py-2 text-sm"
                />
                {sequence.map((step, i) => (
                  <div key={i} className="mb-3">
                    {i !== 0 && (
                      <div className="flex gap-2 items-center flex-wrap text-xs bg-yellow-50 border border-yellow-200 rounded-lg px-2 py-1.5 mb-1.5">
                        <span className="font-medium text-yellow-800 inline-flex items-center gap-1">
                          <Clock size={12} /> Пауза перед письмом {i + 1}:
                        </span>
                        <input
                          type="number"
                          placeholder="Мин"
                          value={step.delayMinutes || 0}
                          onChange={(e) => updateSequence(i, "delayMinutes", Number(e.target.value))}
                          className="border rounded-lg px-2 py-1 w-16 text-sm"
                        />
                        <span>мин</span>
                        <input
                          type="number"
                          placeholder="Сек"
                          value={step.delaySeconds || 0}
                          onChange={(e) => updateSequence(i, "delaySeconds", Number(e.target.value))}
                          className="border rounded-lg px-2 py-1 w-16 text-sm"
                        />
                        <span>сек</span>
                        <span className="text-[10px] text-yellow-700 ml-auto">1 день = 1440 мин</span>
                      </div>
                    )}

                    <div className="border rounded-xl p-2">
                      <div className="font-semibold mb-1 text-sm">Письмо {i + 1}</div>
                      <input
                        placeholder="Тема письма"
                        value={step.subject}
                        onChange={(e) => updateSequence(i, "subject", e.target.value)}
                        className="w-full border rounded-xl px-2 py-1 mb-1 text-sm"
                      />
                      <textarea
                        ref={(el) => (sequenceRefs.current[i] = el)}
                        placeholder="Текст"
                        value={step.text}
                        onChange={(e) => updateSequence(i, "text", e.target.value)}
                        className="w-full border rounded-xl px-2 py-1 mb-1 text-sm"
                        rows={3}
                      />
                    </div>
                  </div>
                ))}
                <button
                  onClick={handleCreateSequenceCampaign}
                  className="w-full md:w-auto px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition shadow-md text-sm inline-flex items-center justify-center gap-2"
                >
                  <Send size={16} /> Запустить цепочку
                </button>
              </>
            ) : (
              <div className="text-center py-6 px-3 bg-yellow-50 border border-yellow-200 rounded-xl">
                <div className="text-3xl mb-2">🔒</div>
                <div className="text-sm font-semibold text-gray-800 mb-1">
                  Доступно на тарифе Gold
                </div>
                <div className="text-xs text-gray-500 mb-4">
                  Цепочки из 3-х писем — только для Gold. Апгрейд тарифа откроет функцию.
                </div>
                <a
                  href="/pricing"
                  className="inline-block px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition shadow-md text-sm font-medium"
                >
                  Перейти к тарифам →
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ===== МОДАЛКА: выбор шаблона ===== */}
      {showTemplatesModal && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-3">
          <div className="bg-white rounded-2xl p-4 md:p-6 max-w-lg w-full shadow-xl max-h-[32vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold flex items-center gap-2">
                <FileText size={18} className="text-purple-600" /> Выбрать шаблон
              </h3>
              <button
                onClick={() => setShowTemplatesModal(false)}
                className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
                title="Закрыть"
              >×</button>
            </div>

            {templates.length === 0 ? (
              <div className="text-center text-gray-500 py-8 text-sm">
                Нет шаблонов. Создайте во вкладке «Шаблоны».
              </div>
            ) : (
              <div className="space-y-2">
                {templates.map(t => (
                  <button
                    key={t.id}
                    onClick={() => applyTemplate(t)}
                    className="w-full text-left p-3 rounded-xl border-2 border-gray-200 hover:border-purple-400 hover:bg-purple-50 transition"
                  >
                    <div className="font-medium text-sm text-gray-800 truncate">
                      {t.name}
                    </div>
                    <div className="text-xs text-gray-500 mt-0.5 truncate">
                      {t.subject || "(без темы)"}
                    </div>
                    <div className="text-xs text-gray-400 mt-1 line-clamp-2 whitespace-pre-wrap">
                      {t.body || "(пусто)"}
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* ===== МОДАЛКА: редактирование отклонённой кампании ===== */}
      {editModalOpen && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-3">
          <div className="bg-white rounded-2xl p-4 md:p-6 max-w-2xl w-full shadow-xl max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold">✏️ Редактировать кампанию #{editForm.id}</h3>
              <button
                onClick={() => setEditModalOpen(false)}
                className="text-gray-400 hover:text-gray-600 text-2xl leading-none"
              >×</button>
            </div>

            <div className="space-y-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Название</label>
                <input
                  type="text"
                  value={editForm.name}
                  onChange={(e) => setEditForm(f => ({ ...f, name: e.target.value }))}
                  className="w-full border rounded-xl px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Тема</label>
                <input
                  type="text"
                  value={editForm.subject}
                  onChange={(e) => setEditForm(f => ({ ...f, subject: e.target.value }))}
                  className="w-full border rounded-xl px-3 py-2 text-sm"
                />
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">
                  Тексты (разделяйте варианты через |)
                </label>
                <textarea
                  value={editForm.texts.join("|")}
                  onChange={(e) => setEditForm(f => ({ ...f, texts: e.target.value.split("|") }))}
                  rows={6}
                  className="w-full border rounded-xl px-3 py-2 text-sm font-mono"
                />
              </div>
            </div>

            <div className="flex flex-col md:flex-row md:justify-end gap-2 mt-5">
              <button
                onClick={() => setEditModalOpen(false)}
                className="px-4 py-2 border border-gray-300 rounded-xl hover:bg-gray-50 transition order-2 md:order-1"
              >
                Отмена
              </button>
              <button
                onClick={handleSaveEdit}
                disabled={savingId === editForm.id}
                className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition order-1 md:order-2 disabled:opacity-50"
              >
                {savingId === editForm.id ? "Сохранение..." : "💾 Сохранить"}
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translate(-50%, -20px); }
          to { opacity: 1; transform: translate(-50%, 0); }
        }
        .animate-fade-in { animation: fade-in 0.3s ease-out; }
      `}</style>
    </div>
  );
}